var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1731,
    height: 1154,
    viewBox: "0 0 1731 1154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_4604)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.824 689.537C520.307 695.519 523.429 701.216 527.135 706.528C532.444 710.346 538.158 713.566 544.175 716.128C538.161 718.696 532.447 721.915 527.135 725.727C523.426 731.055 520.304 736.768 517.824 742.767C515.343 736.768 512.221 731.055 508.512 725.727C503.2 721.915 497.486 718.696 491.473 716.128C497.489 713.566 503.204 710.346 508.512 706.528C512.218 701.216 515.34 695.519 517.824 689.537V689.537Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1388.08 594.788C1390.56 600.787 1393.68 606.5 1397.39 611.827C1402.71 615.546 1408.42 618.668 1414.43 621.139C1408.42 623.707 1402.7 626.926 1397.39 630.739C1393.69 635.99 1390.57 641.622 1388.08 647.538C1385.53 641.517 1382.31 635.801 1378.48 630.499C1373.17 626.677 1367.46 623.457 1361.44 620.899C1367.44 618.515 1373.15 615.472 1378.48 611.827C1382.31 606.525 1385.53 600.81 1388.08 594.788V594.788Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1347.67 788.892C1350.58 788.892 1353.43 788.027 1355.86 786.406C1358.28 784.784 1360.17 782.48 1361.28 779.785C1362.4 777.089 1362.69 774.124 1362.11 771.264C1361.54 768.405 1360.13 765.779 1358.07 763.72C1356 761.661 1353.37 760.262 1350.51 759.699C1347.65 759.136 1344.68 759.434 1341.99 760.557C1339.3 761.68 1337 763.576 1335.39 766.005C1333.78 768.435 1332.92 771.288 1332.93 774.205C1332.93 776.138 1333.31 778.051 1334.05 779.837C1334.79 781.622 1335.88 783.243 1337.25 784.607C1338.62 785.972 1340.24 787.053 1342.03 787.788C1343.82 788.523 1345.73 788.899 1347.67 788.892V788.892Z",
    fill: "url(#paint0_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1311.28 464.426C1312.65 461.044 1314.39 457.825 1316.46 454.826C1319.46 452.749 1322.68 451.011 1326.06 449.642C1322.68 448.274 1319.46 446.535 1316.46 444.459C1314.38 441.466 1312.64 438.245 1311.28 434.859C1309.92 438.245 1308.18 441.466 1306.1 444.459C1303.1 446.546 1299.88 448.285 1296.5 449.642C1299.88 451 1303.1 452.739 1306.1 454.826C1308.17 457.825 1309.91 461.044 1311.28 464.426V464.426Z",
    fill: "url(#paint1_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M397.83 912.058C399.199 908.676 400.937 905.457 403.014 902.458C406.013 900.381 409.232 898.643 412.614 897.274C409.232 895.906 406.013 894.167 403.014 892.09C400.927 889.098 399.188 885.877 397.83 882.491C396.473 885.877 394.734 889.098 392.647 892.09C389.654 894.178 386.433 895.917 383.047 897.274C386.433 898.632 389.654 900.371 392.647 902.458C394.723 905.457 396.462 908.676 397.83 912.058V912.058Z",
    fill: "url(#paint2_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M567.649 249.97C569.017 246.589 570.756 243.369 572.832 240.37C575.825 238.283 579.046 236.544 582.432 235.187C579.055 233.83 575.836 232.108 572.832 230.051C570.756 227.052 569.018 223.832 567.649 220.451C566.28 223.832 564.541 227.052 562.465 230.051C559.456 232.098 556.238 233.819 552.865 235.187C556.247 236.555 559.466 238.294 562.465 240.37C564.542 243.369 566.28 246.589 567.649 249.97Z",
    fill: "url(#paint3_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M480.529 467.449C480.529 468.398 480.248 469.326 479.72 470.115C479.193 470.905 478.443 471.52 477.566 471.883C476.689 472.247 475.724 472.342 474.793 472.156C473.862 471.971 473.007 471.514 472.336 470.843C471.664 470.172 471.207 469.316 471.022 468.385C470.837 467.454 470.932 466.489 471.295 465.612C471.658 464.735 472.274 463.985 473.063 463.458C473.852 462.931 474.78 462.649 475.73 462.649C477.003 462.649 478.223 463.155 479.123 464.055C480.024 464.955 480.529 466.176 480.529 467.449ZM519.648 377.74C517.749 377.74 515.893 378.303 514.315 379.358C512.736 380.413 511.506 381.912 510.779 383.666C510.052 385.42 509.862 387.351 510.233 389.213C510.603 391.075 511.517 392.785 512.86 394.128C514.202 395.47 515.913 396.385 517.775 396.755C519.637 397.125 521.567 396.935 523.321 396.209C525.076 395.482 526.575 394.252 527.63 392.673C528.684 391.094 529.247 389.239 529.247 387.34C529.247 384.794 528.236 382.352 526.436 380.552C524.636 378.752 522.194 377.74 519.648 377.74ZM539.231 495.336C535.342 495.337 531.541 496.495 528.312 498.665C525.084 500.834 522.575 503.915 521.105 507.516C519.634 511.117 519.27 515.074 520.057 518.883C520.844 522.692 522.748 526.18 525.525 528.903C528.303 531.626 531.828 533.46 535.651 534.172C539.475 534.883 543.424 534.44 546.995 532.899C550.566 531.358 553.597 528.788 555.702 525.518C557.807 522.247 558.891 518.424 558.814 514.535C558.714 509.408 556.606 504.525 552.945 500.935C549.283 497.345 544.359 495.335 539.231 495.336V495.336Z",
    fill: "url(#paint4_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M597.023 267.106C594.198 266.436 591.237 266.618 588.516 267.63C585.794 268.642 583.434 270.438 581.733 272.791C580.031 275.144 579.066 277.948 578.957 280.85C578.849 283.751 579.604 286.62 581.125 289.093C582.646 291.566 584.866 293.532 587.505 294.744C590.144 295.956 593.082 296.358 595.949 295.901C598.816 295.443 601.484 294.146 603.614 292.173C605.745 290.201 607.242 287.641 607.918 284.817C608.375 282.938 608.455 280.988 608.153 279.078C607.851 277.168 607.175 275.337 606.162 273.691C605.149 272.044 603.819 270.614 602.251 269.484C600.682 268.354 598.905 267.545 597.023 267.106Z",
    fill: "url(#paint5_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M556.801 591.333C554.692 594.238 552.278 596.909 549.601 599.301C546.247 600.633 542.753 601.583 539.186 602.133C542.1 604.248 544.772 606.678 547.153 609.38C548.486 612.735 549.436 616.229 549.985 619.796C552.109 616.874 554.539 614.187 557.233 611.78C560.595 610.471 564.086 609.521 567.648 608.948C564.725 606.845 562.037 604.431 559.633 601.749C558.323 598.387 557.374 594.895 556.801 591.333V591.333Z",
    fill: "url(#paint6_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1230.26 972.629C1228.17 975.563 1225.76 978.252 1223.06 980.645C1219.7 981.955 1216.21 982.904 1212.65 983.477C1215.57 985.601 1218.26 988.031 1220.66 990.725C1221.97 994.087 1222.92 997.578 1223.49 1001.14C1225.59 998.207 1228 995.518 1230.69 993.125C1234.05 991.792 1237.54 990.842 1241.11 990.293C1238.19 988.169 1235.5 985.739 1233.09 983.045C1231.78 979.683 1230.83 976.192 1230.26 972.629V972.629Z",
    fill: "url(#paint7_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1365.57 781.405C1365.81 780.495 1366.31 779.675 1367 779.046C1367.7 778.417 1368.57 778.007 1369.5 777.867C1370.43 777.727 1371.38 777.863 1372.23 778.258C1373.09 778.654 1373.8 779.291 1374.3 780.09C1374.79 780.89 1375.04 781.817 1375.01 782.757C1374.98 783.697 1374.68 784.607 1374.14 785.376C1373.6 786.145 1372.84 786.738 1371.97 787.081C1371.09 787.425 1370.14 787.504 1369.22 787.308C1368.58 787.174 1367.98 786.912 1367.45 786.538C1366.92 786.165 1366.47 785.688 1366.13 785.136C1365.79 784.584 1365.57 783.969 1365.47 783.328C1365.37 782.687 1365.41 782.032 1365.57 781.405V781.405Z",
    fill: "url(#paint8_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1306.48 859.545C1308.32 859.945 1310.24 859.796 1311.99 859.116C1313.75 858.436 1315.26 857.255 1316.35 855.721C1317.44 854.186 1318.06 852.366 1318.12 850.485C1318.18 848.604 1317.69 846.747 1316.7 845.143C1315.72 843.54 1314.29 842.261 1312.58 841.465C1310.88 840.67 1308.97 840.393 1307.11 840.67C1305.25 840.946 1303.51 841.763 1302.11 843.02C1300.71 844.277 1299.71 845.917 1299.24 847.738C1298.91 848.99 1298.84 850.295 1299.03 851.575C1299.22 852.856 1299.67 854.084 1300.34 855.187C1301.02 856.29 1301.91 857.245 1302.97 857.994C1304.02 858.743 1305.22 859.27 1306.48 859.545Z",
    fill: "url(#paint9_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1314.93 740.799C1318.7 741.717 1322.65 741.497 1326.29 740.168C1329.93 738.838 1333.09 736.458 1335.38 733.329C1337.67 730.201 1338.97 726.464 1339.13 722.592C1339.3 718.72 1338.31 714.887 1336.29 711.578C1334.27 708.269 1331.32 705.633 1327.8 704.004C1324.28 702.375 1320.36 701.826 1316.54 702.426C1312.71 703.027 1309.14 704.749 1306.29 707.376C1303.44 710.003 1301.44 713.417 1300.53 717.184C1299.32 722.225 1300.15 727.541 1302.85 731.968C1305.55 736.395 1309.89 739.571 1314.93 740.799V740.799Z",
    fill: "url(#paint10_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M450.628 922.999C450.43 924.272 449.735 925.414 448.696 926.175C447.656 926.936 446.357 927.252 445.084 927.055C443.811 926.858 442.668 926.163 441.908 925.123C441.147 924.083 440.831 922.784 441.028 921.511C441.126 920.881 441.347 920.276 441.678 919.731C442.01 919.186 442.445 918.712 442.96 918.335C443.475 917.958 444.059 917.687 444.678 917.536C445.298 917.385 445.942 917.358 446.572 917.455C447.202 917.553 447.807 917.774 448.352 918.105C448.897 918.437 449.371 918.872 449.748 919.387C450.125 919.902 450.396 920.486 450.547 921.106C450.698 921.725 450.725 922.369 450.628 922.999V922.999Z",
    fill: "url(#paint11_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M502.707 840.108C500.84 839.862 498.942 840.17 497.249 840.994C495.556 841.819 494.143 843.123 493.186 844.744C492.228 846.366 491.769 848.233 491.865 850.114C491.961 851.994 492.608 853.805 493.725 855.321C494.842 856.836 496.38 857.99 498.148 858.638C499.916 859.286 501.836 859.4 503.668 858.965C505.5 858.531 507.164 857.567 508.452 856.194C509.741 854.821 510.597 853.099 510.914 851.243C511.132 849.97 511.091 848.666 510.793 847.409C510.495 846.153 509.946 844.969 509.18 843.929C508.413 842.89 507.445 842.015 506.333 841.359C505.221 840.702 503.987 840.277 502.707 840.108V840.108Z",
    fill: "url(#paint12_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M504.528 959.143C500.697 958.559 496.779 959.125 493.27 960.769C489.761 962.412 486.819 965.06 484.815 968.377C482.812 971.693 481.837 975.53 482.015 979.401C482.192 983.272 483.514 987.003 485.813 990.122C488.113 993.241 491.285 995.608 494.93 996.923C498.575 998.239 502.528 998.443 506.289 997.511C510.05 996.578 513.45 994.551 516.059 991.686C518.667 988.821 520.367 985.246 520.943 981.414C521.714 976.285 520.419 971.059 517.341 966.884C514.264 962.708 509.655 959.924 504.528 959.143V959.143Z",
    fill: "url(#paint13_radial_329_4604)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.8 901.592C1282.96 889.525 1305.64 871.03 1322.72 847.832C1339.8 824.633 1350.73 797.487 1354.48 768.925C1357.7 745.214 1371.95 722.559 1394.22 719.487C1416.35 716.223 1436.75 747.038 1427.25 783.421C1417.48 821.219 1398.3 855.931 1371.5 884.322C1344.71 912.714 1311.16 933.863 1273.99 945.799C1240.77 956.358 1210.68 947.047 1210.44 936.199C1209.81 924.968 1232.95 912.92 1256.8 901.592Z",
    fill: "url(#paint14_radial_329_4604)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.71 917.096C1280.8 908.211 1312.93 887.607 1336.06 858.511C1359.19 829.414 1372.01 793.469 1372.53 756.303C1372.53 745.167 1379.49 734.991 1389.42 733.887C1399.26 732.783 1408.24 743.487 1407.23 757.886C1404.28 800.92 1387.13 841.755 1358.46 873.984C1329.79 906.214 1291.23 928.012 1248.84 935.96C1235.78 938.36 1224.31 934.808 1224.02 929.96C1223.64 924.92 1233.29 919.928 1244.71 917.096Z",
    fill: "url(#paint15_radial_329_4604)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.58 764.413C1414.88 760.387 1414.3 756.343 1412.9 752.558C1408.22 746.405 1401.34 742.309 1393.7 741.134C1389.41 742.908 1385.78 745.953 1383.28 749.859C1380.78 753.764 1379.54 758.341 1379.73 762.973C1379.25 800.159 1366.29 836.104 1342.92 865.038C1319.56 893.971 1287.15 914.215 1250.9 922.519C1244.36 923.742 1238.14 926.326 1232.66 930.103C1237.89 935.623 1250.04 939.703 1265.11 939.223C1305.48 929.972 1341.8 907.984 1368.72 876.506C1395.63 845.029 1411.71 805.73 1414.58 764.413V764.413Z",
    fill: "url(#paint16_radial_329_4604)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.92 929.048C1284.43 921.281 1323.11 899.517 1351.82 867.22C1380.52 834.924 1397.59 793.953 1400.32 750.831C1401.04 739.695 1395.52 730.24 1388.03 727.744C1380.09 729.572 1372.9 733.794 1367.44 739.839C1366.22 742.893 1365.58 746.15 1365.57 749.439C1365.29 786.635 1352.58 822.668 1329.45 851.8C1306.32 880.931 1274.1 901.484 1237.94 910.185L1235.25 910.905C1228.6 914.392 1222.79 919.31 1218.26 925.304C1221.48 928.904 1231.22 930.968 1241.92 929.048Z",
    fill: "url(#paint17_radial_329_4604)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.71 782.846C1366.75 778.678 1363.13 773.131 1361.31 766.905C1359.5 760.68 1359.57 754.056 1361.52 747.872C1363.47 741.687 1367.21 736.22 1372.27 732.162C1377.33 728.104 1383.47 725.637 1389.93 725.073C1396.39 724.508 1402.88 725.873 1408.56 728.993C1414.24 732.113 1418.88 736.85 1421.87 742.602C1424.86 748.355 1426.08 754.866 1425.37 761.312C1424.66 767.758 1422.06 773.848 1417.89 778.814C1412.3 785.47 1404.3 789.633 1395.64 790.39C1386.98 791.146 1378.37 788.432 1371.71 782.846Z",
    fill: "url(#paint18_radial_329_4604)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1369.26 785.821C1363.72 781.165 1359.67 774.968 1357.65 768.014C1355.62 761.06 1355.7 753.661 1357.88 746.753C1360.06 739.846 1364.24 733.739 1369.89 729.206C1375.54 724.673 1382.4 721.916 1389.62 721.285C1396.83 720.654 1404.07 722.177 1410.42 725.661C1416.77 729.145 1421.95 734.434 1425.29 740.859C1428.64 747.284 1430 754.556 1429.21 761.756C1428.42 768.956 1425.52 775.76 1420.86 781.309C1417.77 784.993 1413.98 788.033 1409.72 790.254C1405.45 792.474 1400.79 793.833 1396 794.252C1391.21 794.671 1386.38 794.142 1381.79 792.695C1377.21 791.249 1372.95 788.913 1369.26 785.821Z",
    fill: "url(#paint19_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1409.87 731.534C1415.46 736.237 1419.32 742.67 1420.83 749.814C1422.35 756.958 1421.43 764.403 1418.24 770.968C1415.04 777.534 1409.74 782.844 1403.18 786.056C1396.62 789.268 1389.18 790.199 1382.03 788.7C1389.27 791.201 1397.15 791.09 1404.32 788.386C1411.48 785.683 1417.47 780.557 1421.25 773.898C1425.03 767.24 1426.36 759.468 1425.01 751.932C1423.66 744.395 1419.71 737.569 1413.86 732.638C1409.69 729.193 1404.75 726.805 1399.46 725.678C1403.25 726.992 1406.78 728.975 1409.87 731.534V731.534Z",
    fill: "url(#paint20_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M1367.87 754.094C1371.7 749.547 1376.68 746.123 1382.3 744.19C1387.92 742.257 1393.96 741.887 1399.77 743.12C1405.58 744.352 1410.95 747.14 1415.3 751.187C1419.65 755.234 1422.82 760.386 1424.46 766.094C1425.73 761.224 1425.86 756.127 1424.83 751.2C1423.81 746.273 1421.67 741.648 1418.57 737.684C1415.47 733.721 1411.49 730.525 1406.96 728.347C1402.42 726.168 1397.44 725.064 1392.41 725.122C1387.38 725.179 1382.43 726.396 1377.94 728.677C1373.46 730.959 1369.56 734.244 1366.55 738.277C1363.54 742.31 1361.5 746.983 1360.59 751.932C1359.68 756.881 1359.92 761.974 1361.3 766.814C1362.52 762.139 1364.77 757.794 1367.87 754.094V754.094Z",
    fill: "url(#paint21_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M1395.85 790.381C1393.02 789.161 1390.37 787.545 1387.98 785.581C1382.89 781.309 1379.29 775.532 1377.7 769.083C1376.1 762.633 1376.59 755.844 1379.1 749.691C1381.61 743.538 1386 738.34 1391.65 734.845C1397.3 731.349 1403.92 729.737 1410.54 730.239C1406.15 727.422 1401.16 725.694 1395.97 725.198C1390.78 724.702 1385.55 725.452 1380.71 727.387C1375.86 729.322 1371.56 732.385 1368.14 736.321C1364.72 740.258 1362.29 744.954 1361.05 750.018C1359.82 755.083 1359.81 760.369 1361.03 765.438C1362.25 770.507 1364.66 775.211 1368.06 779.16C1371.47 783.108 1375.76 786.186 1380.6 788.138C1385.43 790.09 1390.66 790.859 1395.85 790.381V790.381Z",
    fill: "url(#paint22_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1412.08 747.757C1410.11 744.397 1410.16 740.75 1412.08 739.598C1414 738.446 1417.21 740.27 1419.18 743.63C1421.15 746.989 1421.1 750.637 1419.18 751.789C1417.26 752.941 1414.19 751.117 1412.08 747.757Z",
    fill: "url(#paint23_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1418.56 752.077C1419.1 750.891 1419.32 749.583 1419.2 748.285C1419.07 746.986 1418.6 745.745 1417.84 744.686C1416.11 741.71 1413.47 739.886 1411.5 740.366C1410.95 741.55 1410.73 742.86 1410.85 744.16C1410.98 745.46 1411.45 746.703 1412.22 747.758C1413.95 750.733 1416.59 752.461 1418.56 752.077Z",
    fill: "url(#paint24_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1401.57 757.119C1401.36 756.889 1401.21 756.618 1401.13 756.323C1401.04 756.029 1401.02 755.719 1401.07 755.417C1401.12 755.114 1401.24 754.827 1401.41 754.575C1401.59 754.322 1401.81 754.112 1402.08 753.96C1402.35 753.807 1402.64 753.715 1402.95 753.691C1403.25 753.667 1403.56 753.711 1403.85 753.821C1404.13 753.93 1404.39 754.102 1404.6 754.324C1404.81 754.545 1404.97 754.812 1405.07 755.103C1405.27 755.332 1405.42 755.603 1405.51 755.898C1405.59 756.192 1405.61 756.502 1405.56 756.804C1405.51 757.107 1405.4 757.395 1405.22 757.647C1405.05 757.899 1404.82 758.109 1404.55 758.262C1404.29 758.414 1403.99 758.506 1403.69 758.53C1403.38 758.554 1403.07 758.51 1402.79 758.401C1402.5 758.291 1402.24 758.119 1402.03 757.897C1401.82 757.676 1401.66 757.41 1401.57 757.119V757.119Z",
    fill: "url(#paint25_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1401.57 757.119C1401.36 756.889 1401.21 756.618 1401.13 756.323C1401.04 756.029 1401.02 755.719 1401.07 755.417C1401.12 755.114 1401.24 754.827 1401.41 754.575C1401.59 754.322 1401.81 754.112 1402.08 753.96C1402.35 753.807 1402.64 753.715 1402.95 753.691C1403.25 753.667 1403.56 753.711 1403.85 753.821C1404.13 753.93 1404.39 754.102 1404.6 754.324C1404.81 754.545 1404.97 754.812 1405.07 755.103C1405.27 755.332 1405.42 755.603 1405.51 755.898C1405.59 756.192 1405.61 756.502 1405.56 756.804C1405.51 757.107 1405.4 757.395 1405.22 757.647C1405.05 757.899 1404.82 758.109 1404.55 758.262C1404.29 758.414 1403.99 758.506 1403.69 758.53C1403.38 758.554 1403.07 758.51 1402.79 758.401C1402.5 758.291 1402.24 758.119 1402.03 757.897C1401.82 757.676 1401.66 757.41 1401.57 757.119V757.119Z",
    fill: "url(#paint26_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1404.21 758.461C1404.78 758.396 1405.32 758.148 1405.74 757.753C1406.17 757.358 1406.45 756.838 1406.55 756.269C1406.65 755.701 1406.57 755.114 1406.31 754.596C1406.06 754.078 1405.64 753.657 1405.13 753.395C1404.61 753.133 1404.03 753.044 1403.46 753.141C1402.89 753.238 1402.36 753.516 1401.96 753.933C1401.56 754.351 1401.31 754.887 1401.24 755.46C1401.17 756.034 1401.28 756.615 1401.57 757.117C1401.8 757.599 1402.19 757.991 1402.66 758.234C1403.14 758.477 1403.68 758.557 1404.21 758.461V758.461Z",
    fill: "url(#paint27_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1386.59 760.382C1387.08 760.628 1387.51 760.979 1387.84 761.41C1388.18 761.841 1388.41 762.341 1388.53 762.875C1388.65 763.408 1388.65 763.961 1388.53 764.495C1388.41 765.028 1388.18 765.528 1387.84 765.958C1387.5 766.389 1387.08 766.74 1386.59 766.985C1386.1 767.231 1385.56 767.365 1385.02 767.377C1384.47 767.39 1383.93 767.282 1383.43 767.06C1382.93 766.838 1382.48 766.508 1382.13 766.094C1381.64 765.848 1381.21 765.497 1380.88 765.066C1380.54 764.635 1380.3 764.134 1380.18 763.601C1380.06 763.068 1380.06 762.514 1380.18 761.981C1380.3 761.448 1380.54 760.948 1380.88 760.517C1381.21 760.087 1381.64 759.736 1382.13 759.49C1382.62 759.245 1383.16 759.111 1383.7 759.098C1384.25 759.085 1384.79 759.194 1385.29 759.416C1385.79 759.638 1386.23 759.968 1386.59 760.382V760.382Z",
    fill: "url(#paint28_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1381.31 759.949C1380.41 760.447 1379.69 761.222 1379.26 762.16C1378.83 763.098 1378.72 764.15 1378.93 765.158C1379.15 766.167 1379.68 767.08 1380.46 767.761C1381.23 768.441 1382.21 768.855 1383.23 768.939C1384.26 769.023 1385.29 768.773 1386.17 768.228C1387.04 767.682 1387.72 766.868 1388.09 765.908C1388.47 764.948 1388.53 763.892 1388.26 762.896C1387.99 761.901 1387.4 761.019 1386.59 760.381C1385.88 759.748 1384.98 759.364 1384.02 759.286C1383.07 759.208 1382.12 759.441 1381.31 759.949Z",
    fill: "url(#paint29_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1389.61 748.815C1389.03 748.67 1388.48 748.394 1388.01 748.007C1387.54 747.62 1387.17 747.133 1386.92 746.581C1386.66 746.03 1386.54 745.428 1386.55 744.822C1386.56 744.215 1386.71 743.619 1386.98 743.078C1387.26 742.537 1387.65 742.065 1388.13 741.697C1388.62 741.328 1389.17 741.074 1389.77 740.952C1390.36 740.83 1390.98 740.843 1391.57 740.991C1392.15 741.14 1392.7 741.419 1393.17 741.808C1394.26 742.238 1395.13 743.074 1395.62 744.14C1396.1 745.205 1396.15 746.417 1395.76 747.519C1395.11 748.501 1394.1 749.188 1392.95 749.43C1391.8 749.673 1390.6 749.452 1389.61 748.815V748.815Z",
    fill: "url(#paint30_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1395.33 748.19C1395.41 747.19 1395.18 746.188 1394.66 745.327C1394.14 744.466 1393.37 743.789 1392.45 743.391C1392.11 742.938 1391.66 742.579 1391.14 742.346C1390.63 742.114 1390.06 742.015 1389.49 742.061C1388.93 742.106 1388.39 742.293 1387.91 742.605C1387.44 742.916 1387.05 743.343 1386.79 743.844C1386.53 744.345 1386.39 744.904 1386.4 745.471C1386.41 746.037 1386.57 746.591 1386.85 747.083C1387.13 747.574 1387.53 747.986 1388.02 748.28C1388.5 748.574 1389.05 748.742 1389.62 748.766C1390.5 749.299 1391.54 749.53 1392.57 749.426C1393.6 749.323 1394.57 748.889 1395.33 748.19Z",
    fill: "url(#paint31_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1415.87 757.502C1415.34 755.918 1415.87 754.334 1416.59 753.998C1417.31 753.662 1418.8 754.718 1419.33 756.35C1419.86 757.982 1419.33 759.518 1418.56 759.854C1417.79 760.19 1416.4 759.326 1415.87 757.502Z",
    fill: "url(#paint32_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1418.22 759.901C1418.56 759.443 1418.77 758.904 1418.83 758.339C1418.88 757.774 1418.79 757.204 1418.56 756.686C1418.08 755.246 1417.07 754.286 1416.21 754.286C1415.86 754.74 1415.65 755.28 1415.59 755.847C1415.53 756.414 1415.63 756.986 1415.87 757.502C1416.35 758.941 1417.31 759.901 1418.22 759.901Z",
    fill: "url(#paint33_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1403.1 738.783C1401.28 737.007 1400.7 734.703 1401.76 733.647C1402.81 732.591 1405.07 733.167 1406.89 734.943C1408.72 736.719 1409.25 739.023 1408.19 740.079C1407.13 741.134 1404.88 740.559 1403.1 738.783Z",
    fill: "url(#paint34_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1403.1 738.783C1401.28 737.007 1400.7 734.703 1401.76 733.647C1402.81 732.591 1405.07 733.167 1406.89 734.943C1408.72 736.719 1409.25 739.023 1408.19 740.079C1407.13 741.134 1404.88 740.559 1403.1 738.783Z",
    fill: "url(#paint35_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1407.76 740.368C1407.89 739.542 1407.81 738.695 1407.51 737.912C1407.22 737.129 1406.73 736.437 1406.08 735.904C1405.51 735.211 1404.76 734.691 1403.91 734.402C1403.07 734.114 1402.15 734.069 1401.28 734.272C1401.14 735.11 1401.23 735.968 1401.54 736.761C1401.84 737.554 1402.35 738.252 1403.01 738.784C1403.58 739.46 1404.32 739.965 1405.16 740.245C1406 740.524 1406.9 740.567 1407.76 740.368Z",
    fill: "url(#paint36_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1383.28 779.822C1385.15 781.502 1385.87 783.758 1384.91 784.622C1383.95 785.486 1381.6 785.294 1379.73 783.614C1377.85 781.934 1377.09 779.726 1378.09 778.814C1379.1 777.902 1381.17 778.19 1383.28 779.822Z",
    fill: "url(#paint37_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1378.48 778.524C1378.39 779.369 1378.52 780.222 1378.87 780.998C1379.21 781.774 1379.76 782.444 1380.45 782.94C1381.05 783.582 1381.81 784.047 1382.66 784.284C1383.51 784.521 1384.4 784.521 1385.25 784.284C1385.34 783.44 1385.21 782.586 1384.86 781.81C1384.51 781.035 1383.97 780.364 1383.28 779.868C1382.68 779.226 1381.91 778.761 1381.07 778.524C1380.22 778.287 1379.33 778.287 1378.48 778.524Z",
    fill: "url(#paint38_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1369.7 761.295C1370.56 763.023 1370.51 764.798 1369.7 765.374C1368.88 765.95 1367.15 764.942 1366.24 763.263C1365.33 761.583 1365.43 759.759 1366.24 759.231C1367.06 758.703 1368.88 759.615 1369.7 761.295Z",
    fill: "url(#paint39_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1369.7 761.295C1370.56 763.023 1370.51 764.798 1369.7 765.374C1368.88 765.95 1367.15 764.942 1366.24 763.263C1365.33 761.583 1365.43 759.759 1366.24 759.231C1367.06 758.703 1368.88 759.615 1369.7 761.295Z",
    fill: "url(#paint40_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1366.63 759.325C1366.34 759.899 1366.21 760.54 1366.25 761.182C1366.29 761.823 1366.5 762.442 1366.87 762.973C1367.11 763.602 1367.53 764.148 1368.07 764.548C1368.62 764.947 1369.26 765.184 1369.94 765.229C1370.21 764.643 1370.34 763.996 1370.29 763.35C1370.25 762.704 1370.05 762.079 1369.7 761.533C1369.45 760.913 1369.02 760.377 1368.48 759.986C1367.94 759.596 1367.29 759.366 1366.63 759.325V759.325Z",
    fill: "url(#paint41_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1380.88 771.229C1381.6 772.573 1381.55 774.013 1380.88 774.445C1380.21 774.877 1378.86 774.109 1378.14 772.765C1377.42 771.421 1377.47 770.029 1378.14 769.597C1378.81 769.165 1380.16 769.885 1380.88 771.229Z",
    fill: "url(#paint42_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1378.48 769.502C1378.21 769.934 1378.07 770.433 1378.07 770.942C1378.07 771.45 1378.21 771.949 1378.48 772.382C1378.67 772.875 1379 773.304 1379.42 773.618C1379.85 773.933 1380.35 774.12 1380.88 774.157C1381.15 773.716 1381.29 773.21 1381.29 772.694C1381.29 772.178 1381.15 771.671 1380.88 771.23C1380.26 770.078 1379.25 769.358 1378.48 769.502Z",
    fill: "url(#paint43_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1404.55 776.989C1407.91 775.741 1411.17 776.317 1411.94 778.285C1412.7 780.253 1410.54 783.085 1407.14 784.093C1403.73 785.101 1400.51 784.765 1399.75 782.797C1398.98 780.829 1401.23 778.237 1404.55 776.989Z",
    fill: "url(#paint44_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1404.55 776.989C1407.91 775.741 1411.17 776.317 1411.94 778.285C1412.7 780.253 1410.54 783.085 1407.14 784.093C1403.73 785.101 1400.51 784.765 1399.75 782.797C1398.98 780.829 1401.23 778.237 1404.55 776.989Z",
    fill: "url(#paint45_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1399.69 782.03C1400.69 782.702 1401.84 783.101 1403.04 783.185C1404.23 783.27 1405.43 783.036 1406.51 782.51C1409.39 781.454 1411.31 779.294 1411.31 777.71C1410.32 777.037 1409.16 776.638 1407.97 776.554C1406.77 776.47 1405.57 776.703 1404.49 777.23C1401.66 778.094 1399.65 780.206 1399.69 782.03Z",
    fill: "url(#paint46_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1413.9 773.149C1415.05 772.094 1416.44 771.758 1417.07 772.43C1417.69 773.102 1417.07 774.445 1416.16 775.501C1415.25 776.557 1413.66 776.845 1413.04 776.221C1412.41 775.597 1412.8 774.157 1413.9 773.149Z",
    fill: "url(#paint47_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1412.85 775.933C1413.35 776.04 1413.87 776.006 1414.35 775.837C1414.83 775.668 1415.26 775.369 1415.58 774.973C1416.02 774.671 1416.36 774.245 1416.56 773.749C1416.75 773.253 1416.8 772.71 1416.69 772.189C1416.18 772.084 1415.65 772.117 1415.16 772.286C1414.67 772.455 1414.24 772.753 1413.9 773.149C1413.48 773.461 1413.15 773.891 1412.96 774.385C1412.78 774.879 1412.74 775.416 1412.85 775.933V775.933Z",
    fill: "url(#paint48_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1387.65 732.592C1386.21 733.072 1384.82 732.592 1384.53 731.872C1384.24 731.152 1385.2 729.952 1386.64 729.472C1388.08 728.992 1389.47 729.472 1389.76 730.192C1390.05 730.912 1389.09 732.112 1387.65 732.592Z",
    fill: "url(#paint49_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1387.65 732.592C1386.21 733.072 1384.82 732.592 1384.53 731.872C1384.24 731.152 1385.2 729.952 1386.64 729.472C1388.08 728.992 1389.47 729.472 1389.76 730.192C1390.05 730.912 1389.09 732.112 1387.65 732.592Z",
    fill: "url(#paint50_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1389.81 730.526C1389.4 730.221 1388.92 730.029 1388.41 729.97C1387.91 729.911 1387.4 729.987 1386.93 730.19C1385.68 730.574 1384.77 731.486 1384.77 732.254C1385.18 732.56 1385.66 732.752 1386.16 732.811C1386.67 732.87 1387.18 732.794 1387.65 732.59C1388.95 732.158 1389.81 731.294 1389.81 730.526Z",
    fill: "url(#paint51_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1373.68 771.95C1375.27 774.926 1375.12 778.093 1373.35 779.053C1371.57 780.013 1368.88 778.333 1367.3 775.358C1365.71 772.382 1365.86 769.214 1367.63 768.254C1369.41 767.294 1372.19 768.926 1373.68 771.95Z",
    fill: "url(#paint52_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1368.4 768.062C1367.9 769.074 1367.67 770.201 1367.74 771.329C1367.8 772.457 1368.16 773.548 1368.78 774.494C1370.18 777.086 1372.43 778.67 1374.16 778.382C1374.66 777.369 1374.89 776.243 1374.82 775.115C1374.76 773.986 1374.4 772.895 1373.78 771.95C1372.38 769.358 1370.13 767.774 1368.4 768.062Z",
    fill: "url(#paint53_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1391.58 784.094C1391.4 783.89 1391.29 783.625 1391.29 783.35C1391.29 783.075 1391.4 782.809 1391.58 782.606C1391.78 782.41 1392.05 782.299 1392.33 782.299C1392.61 782.299 1392.87 782.41 1393.07 782.606C1393.17 782.7 1393.26 782.815 1393.31 782.943C1393.37 783.071 1393.4 783.21 1393.4 783.35C1393.4 783.49 1393.37 783.628 1393.31 783.756C1393.26 783.884 1393.17 783.999 1393.07 784.094C1392.87 784.279 1392.6 784.382 1392.33 784.382C1392.05 784.382 1391.79 784.279 1391.58 784.094V784.094Z",
    fill: "url(#paint54_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1387.65 779.822C1387.55 779.727 1387.49 779.608 1387.47 779.478C1387.44 779.348 1387.46 779.213 1387.51 779.091C1387.56 778.969 1387.64 778.865 1387.76 778.792C1387.87 778.719 1387.99 778.68 1388.13 778.68C1388.26 778.68 1388.39 778.719 1388.5 778.792C1388.61 778.865 1388.7 778.969 1388.75 779.091C1388.8 779.213 1388.81 779.348 1388.79 779.478C1388.76 779.608 1388.7 779.727 1388.61 779.822C1388.48 779.94 1388.3 780.005 1388.13 780.005C1387.95 780.005 1387.78 779.94 1387.65 779.822V779.822Z",
    fill: "url(#paint55_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1394.99 734.319C1394.82 734.152 1394.71 733.938 1394.66 733.705C1394.61 733.472 1394.63 733.229 1394.72 733.009C1394.81 732.788 1394.97 732.599 1395.16 732.466C1395.36 732.333 1395.59 732.262 1395.83 732.262C1396.07 732.262 1396.3 732.333 1396.5 732.466C1396.7 732.599 1396.85 732.788 1396.94 733.009C1397.03 733.229 1397.06 733.472 1397.01 733.705C1396.96 733.938 1396.84 734.152 1396.67 734.319C1396.45 734.539 1396.15 734.662 1395.83 734.662C1395.52 734.662 1395.22 734.539 1394.99 734.319V734.319Z",
    fill: "url(#paint56_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1401.08 741.758C1400.93 741.589 1400.84 741.366 1400.84 741.134C1400.84 740.903 1400.93 740.68 1401.08 740.51C1401.26 740.349 1401.49 740.259 1401.73 740.259C1401.97 740.259 1402.2 740.349 1402.38 740.51C1402.47 740.595 1402.53 740.696 1402.58 740.807C1402.63 740.919 1402.65 741.038 1402.65 741.158C1402.65 741.279 1402.63 741.398 1402.58 741.509C1402.53 741.621 1402.47 741.722 1402.38 741.806C1402.3 741.895 1402.19 741.965 1402.08 742.012C1401.97 742.058 1401.84 742.08 1401.72 742.075C1401.6 742.071 1401.48 742.04 1401.37 741.985C1401.26 741.931 1401.16 741.853 1401.08 741.758V741.758Z",
    fill: "url(#paint57_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1378.91 741.375C1378.23 740.789 1377.8 739.959 1377.72 739.063C1377.64 738.167 1377.91 737.274 1378.48 736.575C1378.75 736.18 1379.11 735.847 1379.52 735.596C1379.93 735.344 1380.38 735.182 1380.86 735.117C1381.34 735.053 1381.82 735.088 1382.28 735.222C1382.74 735.355 1383.17 735.583 1383.54 735.891C1383.91 736.199 1384.21 736.581 1384.42 737.011C1384.63 737.442 1384.76 737.912 1384.78 738.392C1384.8 738.872 1384.72 739.351 1384.54 739.799C1384.37 740.246 1384.1 740.652 1383.76 740.991C1383.17 741.681 1382.32 742.108 1381.42 742.18C1380.51 742.252 1379.61 741.963 1378.91 741.375V741.375Z",
    fill: "url(#paint58_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1381.07 748.479C1380.83 748.236 1380.7 747.908 1380.7 747.567C1380.7 747.225 1380.83 746.897 1381.07 746.655C1381.31 746.429 1381.63 746.303 1381.96 746.303C1382.29 746.303 1382.61 746.429 1382.85 746.655C1383.05 746.887 1383.16 747.182 1383.16 747.489C1383.17 747.796 1383.06 748.094 1382.86 748.33C1382.67 748.566 1382.39 748.725 1382.09 748.779C1381.79 748.832 1381.48 748.777 1381.21 748.623L1381.07 748.479Z",
    fill: "url(#paint59_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1377.09 745.504C1377 745.418 1376.92 745.314 1376.87 745.199C1376.82 745.083 1376.79 744.958 1376.79 744.832C1376.79 744.705 1376.82 744.58 1376.87 744.465C1376.92 744.349 1377 744.245 1377.09 744.16C1377.27 743.984 1377.51 743.885 1377.76 743.885C1378.01 743.885 1378.25 743.984 1378.43 744.16C1378.61 744.347 1378.71 744.596 1378.71 744.856C1378.71 745.115 1378.61 745.364 1378.43 745.552C1378.24 745.701 1378 745.778 1377.75 745.769C1377.51 745.76 1377.27 745.667 1377.09 745.504V745.504Z",
    fill: "url(#paint60_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1399.17 729.422C1399.02 729.283 1398.92 729.104 1398.88 728.907C1398.84 728.71 1398.85 728.505 1398.93 728.318C1399 728.131 1399.13 727.971 1399.3 727.858C1399.47 727.745 1399.66 727.685 1399.87 727.685C1400.07 727.685 1400.26 727.745 1400.43 727.858C1400.6 727.971 1400.73 728.131 1400.8 728.318C1400.88 728.505 1400.89 728.71 1400.85 728.907C1400.81 729.104 1400.71 729.283 1400.56 729.422C1400.37 729.601 1400.12 729.701 1399.87 729.701C1399.61 729.701 1399.36 729.601 1399.17 729.422V729.422Z",
    fill: "url(#paint61_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1406.18 746.846C1406.05 746.698 1405.98 746.511 1405.98 746.318C1405.98 746.124 1406.05 745.937 1406.18 745.79C1406.32 745.683 1406.49 745.626 1406.66 745.63C1406.84 745.633 1407 745.695 1407.14 745.807C1407.27 745.919 1407.36 746.074 1407.4 746.245C1407.43 746.416 1407.41 746.594 1407.33 746.75C1407.26 746.838 1407.18 746.911 1407.09 746.964C1406.99 747.018 1406.88 747.05 1406.77 747.059C1406.67 747.068 1406.56 747.054 1406.45 747.017C1406.35 746.98 1406.26 746.922 1406.18 746.846V746.846Z",
    fill: "url(#paint62_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1413.33 766.527C1413.03 766.232 1412.83 765.856 1412.74 765.446C1412.66 765.035 1412.7 764.61 1412.86 764.223C1413.02 763.836 1413.29 763.506 1413.64 763.273C1413.99 763.04 1414.39 762.916 1414.81 762.916C1415.23 762.916 1415.64 763.04 1415.99 763.273C1416.34 763.506 1416.61 763.836 1416.77 764.223C1416.93 764.61 1416.97 765.035 1416.88 765.446C1416.8 765.856 1416.6 766.232 1416.3 766.527C1415.91 766.919 1415.37 767.14 1414.81 767.14C1414.26 767.14 1413.72 766.919 1413.33 766.527Z",
    fill: "url(#paint63_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1409.82 756.542C1409.66 756.365 1409.57 756.134 1409.57 755.894C1409.57 755.654 1409.66 755.423 1409.82 755.246C1409.91 755.16 1410.01 755.092 1410.12 755.046C1410.23 754.999 1410.35 754.976 1410.47 754.976C1410.59 754.976 1410.71 754.999 1410.82 755.046C1410.93 755.092 1411.03 755.16 1411.12 755.246C1411.2 755.326 1411.27 755.423 1411.31 755.531C1411.36 755.638 1411.38 755.753 1411.38 755.87C1411.38 755.986 1411.36 756.102 1411.31 756.209C1411.27 756.316 1411.2 756.413 1411.12 756.494C1411.04 756.583 1410.94 756.654 1410.83 756.705C1410.72 756.756 1410.6 756.784 1410.48 756.788C1410.36 756.793 1410.24 756.773 1410.13 756.731C1410.01 756.689 1409.91 756.624 1409.82 756.542V756.542Z",
    fill: "url(#paint64_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1419.18 766.142C1419.08 766.048 1419 765.933 1418.94 765.805C1418.88 765.677 1418.86 765.538 1418.86 765.398C1418.86 765.258 1418.88 765.12 1418.94 764.992C1419 764.864 1419.08 764.749 1419.18 764.654C1419.26 764.52 1419.37 764.404 1419.49 764.316C1419.62 764.227 1419.76 764.167 1419.92 764.141C1420.07 764.114 1420.23 764.121 1420.38 764.162C1420.53 764.203 1420.66 764.276 1420.78 764.376C1420.9 764.476 1420.99 764.601 1421.06 764.742C1421.12 764.882 1421.16 765.036 1421.15 765.19C1421.15 765.345 1421.12 765.498 1421.05 765.637C1420.98 765.777 1420.89 765.9 1420.77 765.998C1420.68 766.12 1420.57 766.222 1420.43 766.296C1420.3 766.371 1420.16 766.416 1420.01 766.43C1419.86 766.444 1419.71 766.425 1419.56 766.375C1419.42 766.326 1419.29 766.246 1419.18 766.142V766.142Z",
    fill: "url(#paint65_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1421.68 757.933C1421.55 757.786 1421.48 757.599 1421.48 757.406C1421.48 757.212 1421.55 757.025 1421.68 756.878C1421.82 756.771 1421.99 756.714 1422.16 756.717C1422.34 756.721 1422.51 756.783 1422.64 756.895C1422.77 757.007 1422.87 757.162 1422.9 757.333C1422.94 757.504 1422.91 757.682 1422.83 757.838C1422.76 757.92 1422.68 757.987 1422.58 758.036C1422.49 758.086 1422.38 758.116 1422.27 758.125C1422.17 758.134 1422.06 758.121 1421.96 758.088C1421.85 758.056 1421.76 758.003 1421.68 757.933V757.933Z",
    fill: "url(#paint66_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1404.3 774.59C1403.99 774.332 1403.74 774.014 1403.55 773.655C1403.37 773.296 1403.25 772.904 1403.22 772.501C1403.19 772.099 1403.24 771.694 1403.37 771.311C1403.5 770.927 1403.7 770.574 1403.97 770.27C1404.49 769.648 1405.24 769.258 1406.05 769.186C1406.86 769.114 1407.66 769.366 1408.29 769.886C1408.9 770.424 1409.28 771.179 1409.36 771.993C1409.43 772.807 1409.18 773.617 1408.67 774.254C1408.13 774.873 1407.37 775.255 1406.56 775.318C1405.74 775.381 1404.93 775.119 1404.3 774.59V774.59Z",
    fill: "url(#paint67_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1402.48 764.127C1402.36 764.015 1402.27 763.881 1402.21 763.732C1402.14 763.584 1402.11 763.424 1402.11 763.263C1402.11 763.101 1402.14 762.942 1402.21 762.793C1402.27 762.645 1402.36 762.511 1402.48 762.399C1402.71 762.19 1403.01 762.074 1403.32 762.074C1403.63 762.074 1403.93 762.19 1404.16 762.399C1404.27 762.511 1404.37 762.645 1404.43 762.793C1404.49 762.942 1404.52 763.101 1404.52 763.263C1404.52 763.424 1404.49 763.584 1404.43 763.732C1404.37 763.881 1404.27 764.015 1404.16 764.127C1403.93 764.347 1403.63 764.47 1403.32 764.47C1403 764.47 1402.7 764.347 1402.48 764.127V764.127Z",
    fill: "url(#paint68_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1398.06 786.972C1397.88 786.785 1397.78 786.535 1397.78 786.276C1397.78 786.017 1397.88 785.768 1398.06 785.58C1398.24 785.404 1398.48 785.306 1398.73 785.306C1398.98 785.306 1399.23 785.404 1399.4 785.58C1399.58 785.76 1399.68 786.001 1399.68 786.252C1399.68 786.503 1399.58 786.745 1399.4 786.924C1399.23 787.096 1398.99 787.196 1398.74 787.205C1398.49 787.214 1398.25 787.131 1398.06 786.972V786.972Z",
    fill: "url(#paint69_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1389.18 776.221C1389.05 776.096 1388.95 775.946 1388.88 775.781C1388.81 775.617 1388.78 775.44 1388.78 775.261C1388.78 775.082 1388.81 774.905 1388.88 774.74C1388.95 774.575 1389.05 774.426 1389.18 774.301C1389.41 774.027 1389.74 773.856 1390.09 773.824C1390.45 773.793 1390.8 773.904 1391.08 774.133C1391.35 774.362 1391.52 774.69 1391.55 775.046C1391.59 775.402 1391.47 775.755 1391.25 776.029C1391.13 776.186 1390.98 776.317 1390.81 776.412C1390.64 776.508 1390.45 776.567 1390.26 776.585C1390.06 776.604 1389.87 776.58 1389.68 776.518C1389.49 776.455 1389.33 776.354 1389.18 776.221Z",
    fill: "url(#paint70_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1384.82 772.141C1384.7 772.029 1384.61 771.895 1384.55 771.747C1384.48 771.598 1384.45 771.439 1384.45 771.277C1384.45 771.116 1384.48 770.956 1384.55 770.808C1384.61 770.659 1384.7 770.525 1384.82 770.413C1385.04 770.193 1385.34 770.07 1385.66 770.07C1385.97 770.07 1386.27 770.193 1386.5 770.413C1386.75 770.617 1386.9 770.911 1386.93 771.23C1386.97 771.55 1386.87 771.869 1386.67 772.117C1386.46 772.366 1386.17 772.523 1385.85 772.554C1385.53 772.586 1385.21 772.489 1384.96 772.285L1384.82 772.141Z",
    fill: "url(#paint71_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1384.29 755.247C1384.19 755.153 1384.1 755.038 1384.05 754.91C1383.99 754.782 1383.96 754.643 1383.96 754.503C1383.96 754.363 1383.99 754.225 1384.05 754.097C1384.1 753.969 1384.19 753.854 1384.29 753.759C1384.49 753.563 1384.76 753.453 1385.03 753.453C1385.31 753.453 1385.58 753.563 1385.78 753.759C1385.96 753.955 1386.06 754.212 1386.06 754.479C1386.06 754.746 1385.96 755.004 1385.78 755.199C1385.69 755.306 1385.57 755.392 1385.45 755.453C1385.32 755.513 1385.18 755.547 1385.04 755.551C1384.9 755.556 1384.76 755.531 1384.63 755.479C1384.51 755.426 1384.39 755.348 1384.29 755.247V755.247Z",
    fill: "url(#paint72_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1375.79 765.758C1375.59 765.544 1375.47 765.26 1375.47 764.966C1375.47 764.671 1375.59 764.388 1375.79 764.174C1375.89 764.068 1376.02 763.984 1376.15 763.926C1376.29 763.869 1376.43 763.839 1376.58 763.839C1376.73 763.839 1376.88 763.869 1377.01 763.926C1377.15 763.984 1377.27 764.068 1377.37 764.174C1377.6 764.365 1377.75 764.639 1377.77 764.936C1377.8 765.233 1377.71 765.529 1377.52 765.758C1377.33 765.987 1377.05 766.131 1376.76 766.158C1376.46 766.185 1376.16 766.093 1375.93 765.902L1375.79 765.758Z",
    fill: "url(#paint73_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1372.67 762.925C1372.5 762.738 1372.4 762.488 1372.4 762.229C1372.4 761.97 1372.5 761.721 1372.67 761.533C1372.86 761.354 1373.11 761.254 1373.37 761.254C1373.63 761.254 1373.88 761.354 1374.07 761.533C1374.26 761.699 1374.39 761.936 1374.41 762.192C1374.43 762.449 1374.35 762.704 1374.19 762.901C1374.02 763.099 1373.78 763.222 1373.53 763.245C1373.27 763.267 1373.02 763.187 1372.82 763.021L1372.67 762.925Z",
    fill: "url(#paint74_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1364.37 756.349C1364.17 756.185 1364.01 755.985 1363.89 755.759C1363.77 755.532 1363.7 755.285 1363.68 755.031C1363.66 754.777 1363.69 754.521 1363.76 754.278C1363.84 754.035 1363.96 753.809 1364.13 753.613C1364.29 753.418 1364.49 753.257 1364.72 753.139C1364.94 753.021 1365.19 752.949 1365.45 752.927C1365.7 752.905 1365.96 752.933 1366.2 753.009C1366.44 753.086 1366.67 753.21 1366.86 753.374C1367.26 753.704 1367.5 754.179 1367.55 754.692C1367.59 755.205 1367.43 755.715 1367.1 756.109C1366.77 756.504 1366.3 756.751 1365.78 756.796C1365.27 756.841 1364.76 756.68 1364.37 756.349V756.349Z",
    fill: "url(#paint75_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1362.07 759.325C1361.96 759.204 1361.91 759.051 1361.91 758.893C1361.91 758.735 1361.96 758.582 1362.07 758.461C1362.18 758.35 1362.34 758.288 1362.5 758.288C1362.66 758.288 1362.81 758.35 1362.93 758.461C1362.98 758.515 1363.03 758.578 1363.05 758.648C1363.08 758.718 1363.1 758.793 1363.1 758.869C1363.1 758.945 1363.08 759.02 1363.05 759.09C1363.03 759.16 1362.98 759.224 1362.93 759.277C1362.81 759.386 1362.66 759.45 1362.51 759.459C1362.35 759.468 1362.19 759.42 1362.07 759.325V759.325Z",
    fill: "url(#paint76_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1363.46 766.91C1363.4 766.864 1363.36 766.809 1363.34 766.747C1363.31 766.685 1363.29 766.618 1363.29 766.549C1363.29 766.481 1363.31 766.414 1363.34 766.352C1363.36 766.29 1363.4 766.235 1363.46 766.19C1363.5 766.137 1363.56 766.096 1363.63 766.067C1363.7 766.039 1363.77 766.024 1363.84 766.024C1363.91 766.024 1363.98 766.039 1364.05 766.067C1364.11 766.096 1364.17 766.137 1364.22 766.19C1364.31 766.287 1364.37 766.416 1364.37 766.549C1364.37 766.683 1364.31 766.812 1364.22 766.91C1364.18 766.969 1364.12 767.017 1364.05 767.051C1363.99 767.084 1363.91 767.101 1363.84 767.101C1363.76 767.101 1363.69 767.084 1363.62 767.051C1363.56 767.017 1363.5 766.969 1363.46 766.91V766.91Z",
    fill: "url(#paint77_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1374.69 782.798C1374.61 782.731 1374.56 782.649 1374.52 782.558C1374.48 782.467 1374.46 782.369 1374.46 782.27C1374.46 782.171 1374.48 782.073 1374.52 781.982C1374.56 781.891 1374.61 781.809 1374.69 781.742C1374.83 781.607 1375.02 781.532 1375.21 781.532C1375.41 781.532 1375.6 781.607 1375.74 781.742C1375.87 781.889 1375.94 782.077 1375.94 782.27C1375.94 782.463 1375.87 782.651 1375.74 782.798C1375.68 782.871 1375.59 782.929 1375.5 782.968C1375.41 783.008 1375.31 783.028 1375.21 783.028C1375.12 783.028 1375.02 783.008 1374.93 782.968C1374.84 782.929 1374.75 782.871 1374.69 782.798V782.798Z",
    fill: "url(#paint78_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1387.6 788.749C1387.55 788.699 1387.51 788.64 1387.48 788.574C1387.45 788.508 1387.44 788.437 1387.44 788.365C1387.44 788.293 1387.45 788.222 1387.48 788.156C1387.51 788.09 1387.55 788.03 1387.6 787.981C1387.71 787.886 1387.84 787.834 1387.99 787.834C1388.13 787.834 1388.26 787.886 1388.37 787.981C1388.46 788.078 1388.51 788.207 1388.51 788.341C1388.51 788.474 1388.46 788.603 1388.37 788.701C1388.33 788.763 1388.27 788.815 1388.21 788.853C1388.14 788.891 1388.07 788.913 1388 788.917C1387.92 788.922 1387.85 788.909 1387.78 788.88C1387.71 788.851 1387.65 788.806 1387.6 788.749V788.749Z",
    fill: "url(#paint79_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1387.31 774.542C1384.38 772.114 1382.24 768.87 1381.16 765.223C1380.08 761.576 1380.1 757.69 1381.23 754.057C1382.36 750.424 1384.55 747.209 1387.51 744.82C1390.47 742.431 1394.07 740.975 1397.86 740.637C1401.65 740.3 1405.45 741.095 1408.79 742.923C1412.13 744.751 1414.85 747.529 1416.6 750.905C1418.36 754.28 1419.07 758.101 1418.65 761.882C1418.23 765.663 1416.69 769.234 1414.24 772.142C1410.97 776.011 1406.31 778.435 1401.27 778.884C1396.23 779.334 1391.21 777.773 1387.31 774.542V774.542Z",
    fill: "url(#paint80_radial_329_4604)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1175.3 865.263C1334.59 705.972 1334.59 447.711 1175.3 288.421C1016.01 129.131 757.747 129.131 598.457 288.421C439.167 447.711 439.167 705.972 598.457 865.263C757.747 1024.55 1016.01 1024.55 1175.3 865.263Z",
    fill: "url(#paint81_radial_329_4604)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.69 652.778C1250.65 475.017 1140.56 296.902 962.797 254.947C785.036 212.991 606.921 323.083 564.966 500.844C523.011 678.605 633.103 856.72 810.863 898.675C988.624 940.63 1166.74 830.538 1208.69 652.778Z",
    fill: "url(#paint82_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25,
    d: "M589.917 610.531C589.911 547.018 608.201 484.847 642.598 431.454C676.996 378.061 726.044 335.706 783.879 309.454C841.714 283.202 905.886 274.165 968.721 283.424C1031.56 292.682 1090.39 319.844 1138.2 361.661C1108.4 327.551 1071.91 299.928 1031 280.504C990.085 261.08 945.615 250.27 900.349 248.744C855.083 247.219 809.986 255.01 767.856 271.635C725.726 288.26 687.462 313.364 655.435 345.391C623.409 377.417 598.305 415.681 581.68 457.811C565.055 499.941 557.264 545.038 558.789 590.304C560.315 635.57 571.125 680.04 590.549 720.955C609.972 761.87 637.596 798.358 671.706 828.155C618.892 767.969 589.816 690.603 589.917 610.531V610.531Z",
    fill: "url(#paint83_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25,
    d: "M636.954 740.511C608.021 683.962 595.992 620.275 602.309 557.069C608.625 493.862 633.018 433.814 672.571 384.11C712.123 334.405 765.158 297.149 825.331 276.798C885.504 256.448 950.266 253.866 1011.87 269.361C969.805 252.517 924.729 244.499 879.438 245.804C834.146 247.11 789.607 257.711 748.584 276.95C707.561 296.19 670.93 323.656 640.967 357.644C611.003 391.632 588.345 431.416 574.4 474.527C560.455 517.638 555.52 563.155 559.902 608.253C564.284 653.351 577.89 697.066 599.874 736.686C621.857 776.306 651.75 810.984 687.697 838.568C723.644 866.151 764.877 886.052 808.836 897.033C734.431 867.47 673.333 811.831 636.954 740.511V740.511Z",
    fill: "url(#paint84_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1034.05 280.688C1070.72 311.942 1098.55 352.282 1114.73 397.67C1130.91 443.058 1134.89 491.9 1126.26 539.308C1117.64 586.716 1096.71 631.026 1065.57 667.802C1034.43 704.578 994.181 732.53 948.846 748.859C903.51 765.188 854.68 769.321 807.245 760.845C759.81 752.369 715.433 731.582 678.558 700.563C641.682 669.544 613.602 629.383 597.128 584.1C580.654 538.817 576.364 490 584.688 442.538C558.392 501.75 550.069 567.383 560.755 631.285C571.441 695.186 600.665 754.54 644.795 801.975C688.926 849.41 746.02 882.835 808.985 898.099C871.95 913.363 938.013 909.793 998.966 887.832C1059.92 865.871 1113.08 826.488 1151.84 774.573C1190.6 722.659 1213.26 660.501 1217 595.82C1220.73 531.139 1205.39 466.785 1172.86 410.752C1140.34 354.718 1092.07 309.475 1034.05 280.64V280.688Z",
    fill: "url(#paint85_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M787.382 258.322C833.457 255.871 879.407 265.054 921.001 285.024C962.595 304.994 998.496 335.109 1025.4 372.595C1052.3 410.082 1069.33 453.734 1074.93 499.533C1080.53 545.331 1074.52 591.803 1057.45 634.667C1040.38 677.532 1012.79 715.411 977.236 744.817C941.681 774.222 899.298 794.208 853.991 802.935C808.684 811.661 761.909 808.846 717.976 794.75C674.042 780.654 634.362 755.729 602.589 722.272C591.713 710.753 581.823 698.342 573.022 685.17C594.726 746.229 633.89 799.566 685.649 838.556C737.409 877.546 799.482 900.47 864.16 904.481C928.837 908.492 993.268 893.413 1049.45 861.117C1105.63 828.822 1151.08 780.732 1180.16 722.823C1209.25 664.913 1220.67 599.736 1213.03 535.387C1205.38 471.038 1179 410.354 1137.16 360.871C1095.31 311.389 1039.86 275.29 977.673 257.059C915.489 238.827 849.319 239.266 787.382 258.322V258.322Z",
    fill: "url(#paint86_radial_329_4604)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.7 320.477C1373.34 278.431 1305 272.479 1184.86 302.622C1157.93 309.342 1129.13 317.789 1099.04 327.581C1106.49 333.141 1113.47 339.305 1119.91 346.012C1129.04 353.846 1137.61 362.315 1145.55 371.355C1159.37 367.18 1172.9 363.244 1185.91 359.836C1306.48 328.013 1338.26 341.741 1343.25 344.908C1342.53 350.764 1333.65 384.219 1234.05 459.24C1153.8 519.622 1042.49 585.427 920.29 644.609C798.086 703.791 677.707 750.445 580.415 776.028C459.699 807.851 428.02 793.98 423.028 790.956C423.748 785.1 432.628 751.693 532.224 676.672C543.12 668.464 554.736 660.113 566.735 651.761C560.124 632.111 556.879 611.486 557.135 590.755C532.08 607.507 508.753 624.354 487.778 640.385C389.958 716.126 352.183 773.34 372.582 815.387C384.438 839.866 412.565 852.105 457.731 852.105C490.082 852.105 531.312 845.834 581.423 833.29C684.283 807.563 813.206 758.365 944.577 694.719C1075.95 631.074 1194.46 560.324 1278.31 495.479C1376.32 419.786 1414.1 362.524 1393.7 320.477Z",
    fill: "url(#paint87_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M953.698 654.931C1346.23 467.738 1403.97 347.311 1362.55 317.696C1323 289.473 1205.69 319.136 1124.14 349.902C1131.67 356.653 1138.81 363.816 1145.55 371.358C1159.37 367.182 1172.91 363.246 1185.91 359.838C1306.48 328.015 1338.26 341.743 1343.25 344.911C1342.53 350.766 1333.65 384.221 1234.06 459.242C1153.8 519.624 1042.49 585.43 920.291 644.611C798.087 703.793 677.708 750.447 580.416 776.03C459.7 807.853 428.021 793.982 423.03 790.958C423.75 785.102 432.629 751.695 532.225 676.674C543.121 668.466 554.737 660.115 566.736 651.763C562.714 639.272 559.965 626.408 558.528 613.364C514.178 645.091 359.288 760.383 394.183 799.165C434.789 844.428 561.12 842.172 953.698 654.931Z",
    fill: "url(#paint88_radial_329_4604)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M513.168 918.151C563.137 918.151 603.645 877.644 603.645 827.675C603.645 777.706 563.137 737.198 513.168 737.198C463.199 737.198 422.691 777.706 422.691 827.675C422.691 877.644 463.199 918.151 513.168 918.151Z",
    fill: "url(#paint89_radial_329_4604)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M513.168 901.064C553.699 901.064 586.557 868.207 586.557 827.675C586.557 787.143 553.699 754.286 513.168 754.286C472.636 754.286 439.778 787.143 439.778 827.675C439.778 868.207 472.636 901.064 513.168 901.064Z",
    fill: "url(#paint90_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M447.313 835.164C447.314 821.076 451.373 807.286 459.004 795.443C466.635 783.6 477.516 774.206 490.345 768.384C503.174 762.562 517.409 760.558 531.347 762.612C545.285 764.666 558.336 770.691 568.941 779.966C562.331 772.398 554.237 766.269 545.16 761.96C536.083 757.65 526.218 755.251 516.176 754.912C506.134 754.573 496.129 756.301 486.782 759.989C477.436 763.677 468.946 769.246 461.842 776.351C454.737 783.456 449.167 791.945 445.479 801.292C441.791 810.639 440.063 820.643 440.402 830.685C440.741 840.728 443.14 850.593 447.45 859.67C451.76 868.746 457.889 876.841 465.456 883.45C453.742 870.094 447.293 852.93 447.313 835.164V835.164Z",
    fill: "url(#paint91_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M457.732 864.011C451.268 851.46 448.563 837.311 449.944 823.261C451.324 809.211 456.73 795.858 465.512 784.804C474.295 773.751 486.081 765.468 499.456 760.949C512.831 756.429 527.226 755.866 540.913 759.327C531.576 755.55 521.562 753.736 511.494 753.999C501.425 754.261 491.519 756.595 482.392 760.853C473.266 765.112 465.114 771.205 458.445 778.753C451.776 786.3 446.733 795.141 443.631 804.722C440.528 814.304 439.433 824.422 440.412 834.446C441.391 844.47 444.425 854.185 449.323 862.985C454.221 871.785 460.88 879.482 468.883 885.596C476.887 891.71 486.064 896.11 495.842 898.522C479.365 892.035 465.816 879.766 457.732 864.011V864.011Z",
    fill: "url(#paint92_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M545.806 762.015C553.553 768.681 559.501 777.187 563.104 786.751C566.708 796.315 567.85 806.632 566.427 816.752C565.004 826.873 561.06 836.474 554.959 844.674C548.859 852.874 540.795 859.409 531.51 863.681C522.225 867.952 512.015 869.822 501.819 869.119C491.623 868.416 481.767 865.162 473.156 859.657C464.544 854.152 457.454 846.572 452.536 837.612C447.619 828.653 445.03 818.601 445.01 808.381C445.021 804.874 445.326 801.374 445.922 797.917C441.729 807.277 439.57 817.42 439.586 827.676C439.573 840.757 443.057 853.603 449.677 864.885C456.296 876.167 465.811 885.475 477.236 891.845C488.66 898.215 501.58 901.416 514.657 901.117C527.734 900.817 540.494 897.027 551.615 890.14C562.736 883.253 571.814 873.519 577.909 861.946C584.005 850.372 586.896 837.38 586.284 824.313C585.672 811.247 581.579 798.582 574.428 787.628C567.278 776.675 557.33 767.832 545.614 762.015H545.806Z",
    fill: "url(#paint93_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M491.091 757.021C501.298 756.503 511.472 758.558 520.678 762.997C529.884 767.436 537.827 774.117 543.778 782.426C549.729 790.735 553.498 800.406 554.737 810.551C555.976 820.696 554.647 830.99 550.871 840.487C547.095 849.984 540.994 858.381 533.127 864.905C525.26 871.43 515.88 875.874 505.848 877.828C495.817 879.783 485.455 879.186 475.714 876.092C465.973 872.998 457.165 867.506 450.1 860.121C447.666 857.571 445.465 854.808 443.524 851.866C448.337 865.418 457.026 877.258 468.511 885.914C479.997 894.57 493.772 899.661 508.126 900.554C522.48 901.447 536.781 898.102 549.25 890.936C561.719 883.77 571.809 873.098 578.264 860.246C584.719 847.395 587.256 832.929 585.559 818.648C583.862 804.366 578.007 790.898 568.72 779.917C559.433 768.935 547.124 760.924 533.323 756.879C519.522 752.834 504.836 752.934 491.091 757.165V757.021Z",
    fill: "url(#paint94_radial_329_4604)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1240.1 585.429C1281.59 585.429 1315.22 551.798 1315.22 510.312C1315.22 468.825 1281.59 435.194 1240.1 435.194C1198.62 435.194 1164.98 468.825 1164.98 510.312C1164.98 551.798 1198.62 585.429 1240.1 585.429Z",
    fill: "url(#paint95_radial_329_4604)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.1 571.221C1273.74 571.221 1301.01 543.951 1301.01 510.312C1301.01 476.672 1273.74 449.402 1240.1 449.402C1206.46 449.402 1179.19 476.672 1179.19 510.312C1179.19 543.951 1206.46 571.221 1240.1 571.221Z",
    fill: "url(#paint96_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1185.43 516.502C1185.47 504.842 1188.85 493.438 1195.18 483.644C1201.51 473.85 1210.51 466.078 1221.13 461.251C1231.74 456.424 1243.52 454.746 1255.06 456.414C1266.6 458.083 1277.42 463.028 1286.23 470.664C1280.74 464.373 1274.02 459.277 1266.48 455.693C1258.95 452.108 1250.75 450.11 1242.41 449.825C1234.07 449.539 1225.76 450.971 1217.99 454.032C1210.22 457.092 1203.17 461.717 1197.27 467.617C1191.36 473.518 1186.74 480.569 1183.67 488.333C1180.61 496.096 1179.17 504.407 1179.45 512.75C1179.73 521.092 1181.72 529.287 1185.3 536.827C1188.88 544.367 1193.98 551.091 1200.26 556.581C1190.62 545.462 1185.35 531.218 1185.43 516.502V516.502Z",
    fill: "url(#paint97_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1194.07 540.455C1188.71 530.026 1186.48 518.272 1187.64 506.605C1188.8 494.938 1193.31 483.855 1200.62 474.688C1207.93 465.522 1217.73 458.662 1228.85 454.934C1239.97 451.206 1251.92 450.769 1263.28 453.674C1255.55 450.616 1247.27 449.175 1238.95 449.443C1230.64 449.71 1222.47 451.678 1214.94 455.227C1207.42 458.775 1200.7 463.828 1195.21 470.074C1189.71 476.319 1185.56 483.625 1183 491.54C1180.44 499.454 1179.53 507.81 1180.32 516.09C1181.12 524.37 1183.6 532.4 1187.62 539.682C1191.64 546.965 1197.11 553.346 1203.69 558.433C1210.28 563.519 1217.83 567.202 1225.89 569.254C1212.12 563.871 1200.8 553.625 1194.07 540.455V540.455Z",
    fill: "url(#paint98_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1267.22 455.738C1273.69 461.257 1278.66 468.316 1281.68 476.263C1284.7 484.209 1285.67 492.788 1284.5 501.208C1283.33 509.629 1280.06 517.62 1274.99 524.444C1269.93 531.269 1263.22 536.707 1255.5 540.258C1247.77 543.809 1239.28 545.359 1230.8 544.764C1222.32 544.169 1214.12 541.449 1206.97 536.854C1199.82 532.259 1193.94 525.937 1189.87 518.472C1185.81 511.006 1183.69 502.637 1183.71 494.136C1183.7 491.209 1183.94 488.287 1184.43 485.401C1179.58 496.307 1178.05 508.396 1180.01 520.166C1181.98 531.936 1187.36 542.87 1195.49 551.608C1203.62 560.347 1214.13 566.505 1225.73 569.319C1237.33 572.133 1249.49 571.478 1260.72 567.436C1271.95 563.394 1281.74 556.142 1288.89 546.582C1296.03 537.022 1300.21 525.575 1300.9 513.661C1301.59 501.748 1298.77 489.893 1292.78 479.57C1286.79 469.247 1277.91 460.909 1267.22 455.594V455.738Z",
    fill: "url(#paint99_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1221.77 451.609C1230.25 451.165 1238.7 452.862 1246.36 456.542C1254.01 460.222 1260.61 465.768 1265.56 472.669C1270.51 479.57 1273.64 487.605 1274.68 496.035C1275.71 504.464 1274.6 513.017 1271.46 520.907C1268.32 528.797 1263.24 535.77 1256.7 541.185C1250.16 546.6 1242.36 550.283 1234.02 551.895C1225.69 553.507 1217.08 552.997 1208.99 550.41C1200.9 547.824 1193.59 543.244 1187.74 537.094C1185.74 534.961 1183.93 532.665 1182.31 530.23C1185.14 538.267 1189.64 545.613 1195.51 551.781C1202.99 559.649 1212.43 565.377 1222.86 568.372C1233.29 571.367 1244.33 571.521 1254.84 568.818C1265.35 566.115 1274.95 560.653 1282.64 552.997C1290.33 545.341 1295.84 535.769 1298.59 525.271C1301.34 514.773 1301.24 503.731 1298.29 493.286C1295.34 482.842 1289.66 473.375 1281.82 465.864C1273.99 458.353 1264.29 453.071 1253.73 450.565C1243.18 448.059 1232.14 448.419 1221.77 451.609V451.609Z",
    fill: "url(#paint100_radial_329_4604)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1396.81 366.269C1396.81 371.015 1395.41 375.655 1392.77 379.602C1390.13 383.548 1386.38 386.624 1382 388.441C1377.61 390.257 1372.79 390.733 1368.13 389.807C1363.48 388.881 1359.2 386.595 1355.84 383.239C1352.49 379.882 1350.2 375.606 1349.28 370.951C1348.35 366.295 1348.83 361.47 1350.64 357.085C1352.46 352.699 1355.53 348.951 1359.48 346.314C1363.43 343.677 1368.07 342.27 1372.81 342.27C1379.18 342.27 1385.28 344.798 1389.78 349.299C1394.29 353.799 1396.81 359.904 1396.81 366.269Z",
    fill: "url(#paint101_radial_329_4604)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.3 366.269C1392.3 370.066 1391.18 373.778 1389.07 376.936C1386.96 380.093 1383.96 382.554 1380.45 384.007C1376.94 385.46 1373.08 385.84 1369.36 385.099C1365.63 384.359 1362.21 382.53 1359.53 379.845C1356.84 377.16 1355.01 373.739 1354.27 370.015C1353.53 366.29 1353.91 362.43 1355.37 358.922C1356.82 355.414 1359.28 352.415 1362.44 350.305C1365.59 348.196 1369.31 347.07 1373.1 347.07C1378.18 347.132 1383.02 349.175 1386.61 352.762C1390.2 356.349 1392.24 361.196 1392.3 366.269V366.269Z",
    fill: "url(#paint102_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1355.44 368.237C1355.35 364.472 1356.36 360.762 1358.36 357.57C1360.36 354.378 1363.25 351.844 1366.68 350.283C1370.11 348.723 1373.92 348.205 1377.64 348.794C1381.36 349.384 1384.82 351.054 1387.6 353.597C1383.96 349.969 1379.04 347.933 1373.9 347.938C1368.77 347.942 1363.84 349.987 1360.22 353.621C1356.59 357.256 1354.55 362.182 1354.56 367.318C1354.56 372.453 1356.61 377.376 1360.24 381.004C1357.13 377.479 1355.42 372.937 1355.44 368.237Z",
    fill: "url(#paint103_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1358.18 375.868C1356.99 373.602 1356.27 371.122 1356.05 368.573C1355.84 366.024 1356.14 363.457 1356.93 361.025C1357.72 358.593 1358.99 356.343 1360.66 354.408C1362.34 352.473 1364.38 350.892 1366.67 349.757C1370.84 347.577 1375.66 347.029 1380.21 348.221C1377.8 347.44 1375.26 347.141 1372.73 347.341C1370.2 347.542 1367.74 348.238 1365.48 349.39C1363.23 350.542 1361.22 352.128 1359.57 354.056C1357.93 355.985 1356.68 358.218 1355.9 360.629C1355.12 363.04 1354.82 365.581 1355.02 368.108C1355.22 370.634 1355.91 373.097 1357.07 375.354C1358.22 377.612 1359.8 379.62 1361.73 381.265C1363.66 382.91 1365.89 384.158 1368.3 384.94C1363.95 383.223 1360.36 380.005 1358.18 375.868V375.868Z",
    fill: "url(#paint104_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1381.5 348.846C1383.58 350.61 1385.18 352.87 1386.15 355.417C1387.12 357.965 1387.44 360.716 1387.06 363.416C1386.68 366.116 1385.63 368.677 1384 370.861C1382.37 373.045 1380.21 374.781 1377.73 375.908C1375.24 377.035 1372.52 377.516 1369.8 377.307C1367.08 377.098 1364.46 376.206 1362.18 374.713C1359.9 373.22 1358.03 371.174 1356.75 368.767C1355.47 366.359 1354.82 363.667 1354.86 360.941C1354.86 360.006 1354.96 359.073 1355.15 358.157C1354.04 360.648 1353.46 363.348 1353.47 366.077C1353.54 369.468 1354.5 372.78 1356.27 375.677C1358.03 378.574 1360.53 380.953 1363.51 382.571C1366.49 384.19 1369.84 384.99 1373.23 384.89C1376.62 384.791 1379.92 383.795 1382.8 382.005C1385.68 380.215 1388.04 377.694 1389.63 374.699C1391.22 371.703 1391.99 368.34 1391.85 364.951C1391.72 361.563 1390.69 358.27 1388.88 355.407C1387.06 352.544 1384.51 350.214 1381.5 348.654V348.846Z",
    fill: "url(#paint105_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1367.01 347.549C1369.71 347.407 1372.41 347.948 1374.84 349.12C1377.28 350.293 1379.38 352.06 1380.96 354.258C1382.54 356.457 1383.53 359.017 1383.86 361.702C1384.19 364.388 1383.84 367.112 1382.83 369.625C1381.83 372.138 1380.21 374.359 1378.13 376.083C1376.05 377.807 1373.56 378.978 1370.9 379.49C1368.25 380.002 1365.51 379.837 1362.93 379.011C1360.35 378.185 1358.03 376.724 1356.16 374.764C1355.53 374.087 1354.96 373.365 1354.43 372.604C1355.36 375.158 1356.79 377.494 1358.66 379.467C1361.04 381.884 1364.02 383.627 1367.29 384.518C1370.56 385.41 1374.01 385.419 1377.29 384.543C1380.57 383.668 1383.55 381.94 1385.95 379.536C1388.34 377.131 1390.05 374.136 1390.91 370.854C1391.77 367.573 1391.74 364.122 1390.83 360.854C1389.93 357.586 1388.17 354.616 1385.74 352.248C1383.31 349.88 1380.3 348.198 1377.01 347.372C1373.72 346.547 1370.27 346.607 1367.01 347.549V347.549Z",
    fill: "url(#paint106_radial_329_4604)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1077.77 584.42C1077.77 589.167 1076.36 593.807 1073.73 597.753C1071.09 601.7 1067.34 604.776 1062.96 606.592C1058.57 608.409 1053.75 608.884 1049.09 607.958C1044.44 607.032 1040.16 604.746 1036.8 601.39C1033.45 598.034 1031.16 593.757 1030.23 589.102C1029.31 584.447 1029.78 579.621 1031.6 575.236C1033.42 570.851 1036.49 567.103 1040.44 564.465C1044.39 561.828 1049.03 560.421 1053.77 560.421C1060.14 560.421 1066.24 562.949 1070.74 567.45C1075.24 571.951 1077.77 578.055 1077.77 584.42V584.42Z",
    fill: "url(#paint107_radial_329_4604)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.21 584.42C1073.21 588.217 1072.09 591.929 1069.98 595.087C1067.87 598.244 1064.87 600.705 1061.36 602.158C1057.85 603.611 1053.99 603.991 1050.27 603.25C1046.54 602.51 1043.12 600.681 1040.44 597.996C1037.75 595.311 1035.93 591.89 1035.18 588.166C1034.44 584.441 1034.82 580.581 1036.28 577.073C1037.73 573.565 1040.19 570.566 1043.35 568.456C1046.51 566.347 1050.22 565.221 1054.01 565.221C1059.11 565.221 1063.99 567.244 1067.59 570.844C1071.19 574.445 1073.21 579.328 1073.21 584.42Z",
    fill: "url(#paint108_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1036.4 586.533C1036.4 581.441 1038.42 576.558 1042.02 572.957C1045.62 569.356 1050.51 567.334 1055.6 567.334C1060.3 567.317 1064.84 569.025 1068.37 572.134C1066.57 570.337 1064.44 568.912 1062.09 567.94C1059.74 566.968 1057.23 566.467 1054.69 566.467C1052.15 566.467 1049.63 566.968 1047.28 567.94C1044.94 568.912 1042.8 570.337 1041.01 572.134C1039.21 573.93 1037.79 576.063 1036.81 578.41C1035.84 580.757 1035.34 583.272 1035.34 585.813C1035.34 588.354 1035.84 590.869 1036.81 593.216C1037.79 595.563 1039.21 597.696 1041.01 599.492C1037.92 595.89 1036.28 591.274 1036.4 586.533V586.533Z",
    fill: "url(#paint109_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1039.13 594.02C1037.33 590.706 1036.55 586.936 1036.88 583.181C1037.22 579.426 1038.64 575.851 1040.99 572.903C1043.34 569.954 1046.51 567.763 1050.1 566.602C1053.68 565.441 1057.53 565.361 1061.16 566.373C1058.75 565.588 1056.2 565.287 1053.66 565.487C1051.13 565.687 1048.66 566.384 1046.4 567.539C1044.13 568.693 1042.12 570.282 1040.47 572.215C1038.82 574.148 1037.56 576.387 1036.78 578.804C1035.99 581.222 1035.69 583.77 1035.89 586.304C1036.09 588.837 1036.79 591.307 1037.95 593.571C1039.1 595.835 1040.69 597.85 1042.62 599.5C1044.55 601.15 1046.79 602.403 1049.21 603.188C1044.86 601.444 1041.28 598.189 1039.13 594.02V594.02Z",
    fill: "url(#paint110_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1062.46 567.044C1064.51 568.806 1066.08 571.055 1067.04 573.585C1067.99 576.114 1068.29 578.843 1067.92 581.52C1067.54 584.197 1066.5 586.736 1064.88 588.905C1063.27 591.073 1061.14 592.801 1058.68 593.93C1056.22 595.059 1053.52 595.552 1050.83 595.364C1048.13 595.176 1045.52 594.313 1043.25 592.855C1040.97 591.397 1039.1 589.389 1037.8 587.018C1036.5 584.647 1035.82 581.987 1035.82 579.284C1035.75 578.373 1035.75 577.458 1035.82 576.548C1034.36 579.99 1033.93 583.785 1034.6 587.465C1035.27 591.145 1036.99 594.551 1039.56 597.264C1042.14 599.977 1045.45 601.879 1049.09 602.737C1052.73 603.595 1056.54 603.371 1060.05 602.093C1063.57 600.815 1066.63 598.539 1068.87 595.543C1071.11 592.547 1072.43 588.963 1072.66 585.23C1072.89 581.498 1072.02 577.779 1070.17 574.531C1068.31 571.284 1065.55 568.648 1062.22 566.948L1062.46 567.044Z",
    fill: "url(#paint111_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1047.96 565.702C1050.68 565.55 1053.38 566.084 1055.84 567.254C1058.29 568.425 1060.41 570.194 1062 572.4C1063.58 574.605 1064.59 577.175 1064.92 579.872C1065.26 582.569 1064.9 585.307 1063.9 587.832C1062.89 590.357 1061.27 592.588 1059.17 594.319C1057.08 596.051 1054.58 597.227 1051.91 597.738C1049.24 598.25 1046.49 598.08 1043.9 597.246C1041.32 596.412 1038.98 594.939 1037.12 592.965C1036.5 592.262 1035.92 591.525 1035.39 590.757C1036.29 593.318 1037.73 595.657 1039.61 597.621C1041.99 600.037 1044.97 601.78 1048.24 602.672C1051.52 603.563 1054.97 603.572 1058.24 602.697C1061.52 601.821 1064.51 600.094 1066.9 597.689C1069.29 595.285 1071 592.289 1071.86 589.007C1072.72 585.726 1072.7 582.275 1071.79 579.007C1070.88 575.739 1069.12 572.77 1066.69 570.402C1064.26 568.033 1061.25 566.351 1057.96 565.526C1054.67 564.7 1051.22 564.761 1047.96 565.702V565.702Z",
    fill: "url(#paint112_radial_329_4604)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M652.076 833.1C665.304 833.1 676.027 822.377 676.027 809.149C676.027 795.921 665.304 785.198 652.076 785.198C638.848 785.198 628.125 795.921 628.125 809.149C628.125 822.377 638.848 833.1 652.076 833.1Z",
    fill: "url(#paint113_radial_329_4604)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M652.075 828.539C662.784 828.539 671.466 819.857 671.466 809.148C671.466 798.438 662.784 789.756 652.075 789.756C641.365 789.756 632.684 798.438 632.684 809.148C632.684 819.857 641.365 828.539 652.075 828.539Z",
    fill: "url(#paint114_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M634.51 811.116C634.455 807.362 635.502 803.675 637.521 800.51C639.541 797.345 642.443 794.841 645.871 793.309C649.298 791.776 653.099 791.283 656.804 791.888C660.509 792.494 663.956 794.172 666.717 796.716C664.92 794.917 662.787 793.489 660.439 792.514C658.09 791.538 655.573 791.035 653.03 791.033C650.487 791.031 647.969 791.53 645.619 792.501C643.269 793.472 641.133 794.896 639.334 796.692C637.534 798.489 636.106 800.622 635.131 802.97C634.156 805.319 633.653 807.836 633.65 810.379C633.646 815.514 635.682 820.441 639.31 824.075C636.156 820.501 634.446 815.882 634.51 811.116V811.116Z",
    fill: "url(#paint115_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M637.434 818.749C635.643 815.439 634.864 811.676 635.195 807.927C635.525 804.178 636.95 800.609 639.292 797.663C641.634 794.717 644.791 792.525 648.369 791.359C651.947 790.192 655.789 790.103 659.417 791.102C655.741 789.5 651.655 789.089 647.734 789.927C643.812 790.765 640.251 792.81 637.551 795.775C634.851 798.74 633.147 802.476 632.678 806.458C632.21 810.441 633 814.47 634.938 817.981C636.209 820.439 637.988 822.6 640.155 824.321C642.323 826.042 644.831 827.284 647.513 827.965C643.138 826.232 639.551 822.952 637.434 818.749V818.749Z",
    fill: "url(#paint116_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M660.714 791.772C662.773 793.528 664.357 795.773 665.321 798.302C666.284 800.83 666.596 803.56 666.228 806.24C665.86 808.921 664.823 811.466 663.213 813.64C661.603 815.815 659.472 817.55 657.016 818.685C654.56 819.82 651.857 820.318 649.158 820.135C646.458 819.952 643.848 819.092 641.568 817.635C639.288 816.179 637.411 814.172 636.11 811.8C634.809 809.427 634.126 806.766 634.123 804.06C634.05 803.134 634.05 802.203 634.123 801.276C633.026 803.756 632.454 806.436 632.443 809.148C632.502 812.541 633.458 815.857 635.215 818.76C636.972 821.663 639.467 824.048 642.446 825.673C645.425 827.298 648.781 828.104 652.173 828.01C655.565 827.916 658.871 826.925 661.755 825.137C664.639 823.349 666.998 820.829 668.591 817.833C670.184 814.837 670.955 811.473 670.825 808.082C670.695 804.691 669.668 801.396 667.85 798.531C666.032 795.666 663.487 793.334 660.474 791.772H660.714Z",
    fill: "url(#paint117_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M646.268 790.478C648.969 790.336 651.663 790.877 654.101 792.049C656.539 793.222 658.643 794.989 660.219 797.188C661.795 799.386 662.792 801.946 663.12 804.632C663.447 807.317 663.094 810.041 662.092 812.554C661.09 815.067 659.473 817.288 657.388 819.012C655.303 820.736 652.818 821.908 650.162 822.419C647.505 822.931 644.763 822.766 642.187 821.94C639.611 821.114 637.284 819.654 635.42 817.693C634.776 817.03 634.198 816.307 633.692 815.533C634.599 818.083 636.02 820.419 637.868 822.396C640.246 824.814 643.222 826.559 646.493 827.453C649.764 828.348 653.213 828.36 656.49 827.489C659.767 826.617 662.755 824.894 665.15 822.493C667.545 820.092 669.261 817.1 670.124 813.82C670.987 810.541 670.966 807.091 670.063 803.823C669.16 800.554 667.408 797.583 664.984 795.211C662.56 792.84 659.552 791.152 656.264 790.321C652.977 789.489 649.528 789.544 646.268 790.478V790.478Z",
    fill: "url(#paint118_radial_329_4604)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M707.756 770.989C720.984 770.989 731.707 760.266 731.707 747.038C731.707 733.81 720.984 723.087 707.756 723.087C694.528 723.087 683.805 733.81 683.805 747.038C683.805 760.266 694.528 770.989 707.756 770.989Z",
    fill: "url(#paint119_radial_329_4604)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M707.755 766.43C718.464 766.43 727.146 757.748 727.146 747.039C727.146 736.329 718.464 727.647 707.755 727.647C697.045 727.647 688.363 736.329 688.363 747.039C688.363 757.748 697.045 766.43 707.755 766.43Z",
    fill: "url(#paint120_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M690.328 749.007C690.274 745.253 691.321 741.566 693.34 738.401C695.359 735.236 698.262 732.733 701.689 731.2C705.117 729.668 708.918 729.174 712.623 729.78C716.328 730.385 719.774 732.064 722.535 734.608C720.736 732.808 718.599 731.381 716.248 730.407C713.897 729.433 711.377 728.932 708.832 728.932C706.287 728.932 703.767 729.433 701.416 730.407C699.064 731.381 696.928 732.808 695.128 734.608C693.329 736.407 691.901 738.544 690.927 740.895C689.953 743.246 689.452 745.766 689.452 748.311C689.452 750.856 689.953 753.376 690.927 755.728C691.901 758.079 693.329 760.215 695.128 762.015C691.996 758.409 690.289 753.783 690.328 749.007V749.007Z",
    fill: "url(#paint121_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M693.113 756.638C691.323 753.328 690.544 749.564 690.874 745.815C691.205 742.067 692.629 738.497 694.972 735.552C697.314 732.606 700.47 730.414 704.048 729.247C707.626 728.081 711.468 727.991 715.097 728.991C711.421 727.388 707.335 726.977 703.413 727.816C699.492 728.654 695.931 730.699 693.231 733.663C690.531 736.628 688.827 740.364 688.358 744.347C687.889 748.329 688.68 752.359 690.618 755.87C691.884 758.332 693.661 760.495 695.829 762.217C697.998 763.938 700.508 765.178 703.193 765.853C698.817 764.121 695.23 760.841 693.113 756.638V756.638Z",
    fill: "url(#paint122_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M716.394 729.664C718.453 731.42 720.037 733.665 721.001 736.193C721.964 738.721 722.276 741.452 721.908 744.132C721.539 746.812 720.503 749.357 718.893 751.532C717.283 753.707 715.152 755.441 712.696 756.576C710.24 757.711 707.537 758.21 704.838 758.027C702.138 757.843 699.528 756.984 697.248 755.527C694.968 754.07 693.091 752.064 691.79 749.691C690.489 747.319 689.806 744.657 689.803 741.952C689.706 741.026 689.706 740.093 689.803 739.168C688.682 741.64 688.109 744.325 688.123 747.039C688.182 750.432 689.138 753.749 690.895 756.652C692.652 759.554 695.147 761.94 698.126 763.565C701.105 765.19 704.461 765.996 707.853 765.902C711.245 765.808 714.551 764.816 717.435 763.029C720.319 761.241 722.678 758.721 724.271 755.725C725.864 752.729 726.635 749.364 726.505 745.974C726.375 742.583 725.348 739.287 723.53 736.422C721.712 733.557 719.167 731.225 716.154 729.664H716.394Z",
    fill: "url(#paint123_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M701.944 728.367C704.645 728.225 707.339 728.766 709.777 729.938C712.215 731.111 714.319 732.878 715.895 735.077C717.471 737.275 718.468 739.835 718.796 742.521C719.123 745.206 718.77 747.931 717.768 750.444C716.766 752.957 715.149 755.177 713.064 756.901C710.979 758.625 708.494 759.797 705.838 760.308C703.181 760.82 700.439 760.655 697.863 759.83C695.287 759.004 692.96 757.543 691.096 755.582C690.439 754.918 689.845 754.195 689.32 753.422C690.264 755.965 691.699 758.298 693.544 760.286C695.922 762.703 698.898 764.448 702.169 765.343C705.439 766.237 708.889 766.249 712.166 765.378C715.443 764.507 718.431 762.783 720.826 760.382C723.221 757.981 724.937 754.989 725.8 751.709C726.663 748.43 726.642 744.981 725.739 741.712C724.836 738.443 723.084 735.472 720.66 733.1C718.236 730.729 715.228 729.042 711.94 728.21C708.653 727.379 705.204 727.433 701.944 728.367V728.367Z",
    fill: "url(#paint124_radial_329_4604)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M399.317 819.515C399.317 824.262 397.909 828.902 395.272 832.848C392.635 836.795 388.887 839.871 384.502 841.687C380.116 843.504 375.291 843.979 370.635 843.053C365.98 842.127 361.704 839.841 358.348 836.485C354.991 833.129 352.706 828.853 351.78 824.197C350.853 819.542 351.329 814.716 353.145 810.331C354.962 805.946 358.038 802.198 361.984 799.561C365.931 796.924 370.571 795.516 375.317 795.516C381.682 795.516 387.787 798.045 392.287 802.545C396.788 807.046 399.317 813.15 399.317 819.515V819.515Z",
    fill: "url(#paint125_radial_329_4604)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M394.519 819.515C394.519 823.312 393.393 827.024 391.283 830.182C389.173 833.339 386.175 835.8 382.667 837.253C379.158 838.706 375.298 839.086 371.574 838.346C367.85 837.605 364.429 835.776 361.743 833.091C359.058 830.406 357.23 826.985 356.489 823.261C355.748 819.537 356.128 815.676 357.582 812.168C359.035 808.66 361.496 805.661 364.653 803.552C367.81 801.442 371.522 800.316 375.319 800.316C380.411 800.316 385.295 802.339 388.895 805.939C392.496 809.54 394.519 814.423 394.519 819.515Z",
    fill: "url(#paint126_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M357.848 821.723C357.754 817.958 358.77 814.248 360.768 811.056C362.766 807.864 365.659 805.33 369.087 803.769C372.515 802.209 376.326 801.691 380.045 802.28C383.765 802.87 387.229 804.54 390.007 807.083C388.207 805.287 386.072 803.862 383.722 802.891C381.372 801.92 378.853 801.422 376.311 801.424C373.768 801.426 371.25 801.929 368.902 802.904C366.554 803.879 364.42 805.308 362.624 807.107C360.828 808.907 359.403 811.042 358.432 813.392C357.461 815.743 356.963 818.261 356.965 820.803C356.967 823.346 357.47 825.864 358.445 828.212C359.42 830.56 360.848 832.694 362.648 834.49C359.539 830.965 357.832 826.422 357.848 821.723V821.723Z",
    fill: "url(#paint127_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M360.582 829.163C358.77 825.848 357.976 822.072 358.3 818.308C358.624 814.544 360.051 810.959 362.403 808.002C364.755 805.045 367.927 802.848 371.522 801.686C375.117 800.524 378.975 800.448 382.613 801.468C380.192 800.674 377.639 800.364 375.099 800.557C372.559 800.749 370.082 801.44 367.809 802.59C365.536 803.74 363.511 805.327 361.851 807.259C360.191 809.191 358.928 811.431 358.134 813.852C357.34 816.272 357.03 818.825 357.222 821.366C357.415 823.906 358.106 826.383 359.256 828.656C360.406 830.929 361.992 832.954 363.924 834.614C365.857 836.274 368.097 837.537 370.517 838.331C366.227 836.544 362.707 833.297 360.582 829.163V829.163Z",
    fill: "url(#paint128_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M383.911 802.14C385.959 803.9 387.533 806.147 388.487 808.675C389.441 811.202 389.745 813.928 389.371 816.603C388.997 819.279 387.957 821.817 386.347 823.986C384.736 826.154 382.607 827.884 380.154 829.015C377.701 830.147 375.003 830.644 372.308 830.461C369.613 830.278 367.007 829.422 364.729 827.97C362.452 826.517 360.575 824.516 359.272 822.15C357.969 819.784 357.281 817.128 357.272 814.427C357.278 813.494 357.358 812.563 357.512 811.643C356.132 814.6 355.529 817.86 355.76 821.115C355.99 824.37 357.046 827.512 358.829 830.246C360.611 832.979 363.06 835.213 365.945 836.737C368.831 838.26 372.057 839.024 375.319 838.954C379.826 839.207 384.277 837.863 387.891 835.16C391.506 832.456 394.052 828.566 395.084 824.172C396.115 819.777 395.565 815.16 393.53 811.131C391.496 807.102 388.107 803.919 383.959 802.14H383.911Z",
    fill: "url(#paint129_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M369.414 800.844C372.116 800.703 374.81 801.243 377.248 802.416C379.685 803.589 381.789 805.356 383.365 807.554C384.941 809.753 385.939 812.313 386.266 814.998C386.594 817.684 386.24 820.408 385.239 822.921C384.237 825.434 382.619 827.655 380.534 829.379C378.45 831.102 375.965 832.274 373.308 832.786C370.652 833.298 367.909 833.133 365.333 832.307C362.757 831.481 360.43 830.02 358.567 828.059C357.939 827.383 357.361 826.661 356.839 825.899C358.134 829.412 360.427 832.469 363.437 834.694C366.447 836.92 370.041 838.217 373.779 838.427C377.516 838.636 381.233 837.748 384.473 835.873C387.712 833.997 390.333 831.215 392.012 827.87C393.691 824.524 394.356 820.761 393.924 817.043C393.492 813.324 391.983 809.814 389.581 806.942C387.18 804.07 383.992 801.963 380.409 800.88C376.826 799.796 373.004 799.784 369.414 800.844V800.844Z",
    fill: "url(#paint130_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25,
    d: "M779.079 587.54C841.666 587.54 892.402 536.803 892.402 474.216C892.402 411.629 841.666 360.892 779.079 360.892C716.492 360.892 665.755 411.629 665.755 474.216C665.755 536.803 716.492 587.54 779.079 587.54Z",
    fill: "url(#paint131_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25,
    d: "M972.032 576.357C996.208 576.357 1015.81 556.759 1015.81 532.583C1015.81 508.407 996.208 488.809 972.032 488.809C947.856 488.809 928.258 508.407 928.258 532.583C928.258 556.759 947.856 576.357 972.032 576.357Z",
    fill: "url(#paint132_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25,
    d: "M1038.65 456.937C1038.69 460.967 1037.53 464.917 1035.32 468.284C1033.1 471.651 1029.94 474.283 1026.22 475.845C1022.51 477.407 1018.41 477.828 1014.46 477.055C1010.5 476.281 1006.87 474.349 1004.01 471.503C1001.16 468.656 999.218 465.026 998.436 461.073C997.653 457.119 998.064 453.023 999.617 449.304C1001.17 445.586 1003.79 442.413 1007.16 440.191C1010.52 437.969 1014.47 436.798 1018.5 436.826C1023.83 436.851 1028.93 438.977 1032.71 442.742C1036.48 446.506 1038.62 451.607 1038.65 456.937V456.937Z",
    fill: "url(#paint133_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M969.824 783.857C974.805 762.753 961.735 741.607 940.63 736.626C919.526 731.645 898.38 744.715 893.399 765.819C888.418 786.923 901.488 808.07 922.592 813.051C943.697 818.032 964.843 804.961 969.824 783.857Z",
    fill: "url(#paint134_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M1064.04 789.518C1082.02 789.518 1096.59 774.948 1096.59 756.975C1096.59 739.002 1082.02 724.432 1064.04 724.432C1046.07 724.432 1031.5 739.002 1031.5 756.975C1031.5 774.948 1046.07 789.518 1064.04 789.518Z",
    fill: "url(#paint135_radial_329_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M475.882 838.451C476.796 840.465 477.034 842.713 476.564 844.909C476.095 847.106 474.94 849.153 473.246 850.791C471.552 852.43 469.394 853.585 467.047 854.112C464.699 854.639 462.267 854.514 460.058 853.752C457.849 852.99 455.962 851.625 454.637 849.831C453.312 848.037 452.607 845.894 452.613 843.674C452.618 841.453 453.334 839.254 454.668 837.356C456.003 835.458 457.896 833.945 460.109 833.009C463.072 831.757 466.397 831.627 469.354 832.647C472.311 833.667 474.659 835.754 475.882 838.451V838.451Z",
    fill: "url(#paint136_radial_329_4604)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M406.522 421.144C410.418 404.583 418.964 388.835 431.366 375.369C443.767 361.903 459.619 351.157 477.442 344.134C492.224 338.248 504.694 326.439 503.376 313.586C502.203 300.78 479.357 294.832 457.351 306.39C434.473 318.341 414.974 334.96 400.668 354.702C386.363 374.443 377.716 396.663 375.534 419.293C373.653 439.497 384.096 454.533 391.112 452.787C398.432 451.187 402.762 436.302 406.522 421.144Z",
    fill: "url(#paint137_radial_329_4604)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M397.237 430.411C397.701 409.24 406.278 388.198 421.625 370.58C436.973 352.962 458.223 339.763 482.049 333.051C489.21 331.123 494.742 325.576 494.007 319.98C493.285 314.437 485.096 311.407 475.983 314.447C448.738 323.5 424.972 339.9 408.416 361.073C391.86 382.245 383.45 406.992 384.506 431.43C384.861 438.948 388.814 444.573 391.974 443.891C395.271 443.227 397.078 437.115 397.237 430.411Z",
    fill: "url(#paint138_radial_329_4604)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M472.082 309.719C474.69 308.841 477.438 308.438 480.137 308.538C484.875 310.01 488.581 313.055 490.474 317.032C489.933 319.693 488.46 322.225 486.254 324.286C484.047 326.346 481.214 327.837 478.136 328.556C453.714 335.411 431.938 348.885 416.304 366.814C400.67 384.743 392.084 406.088 391.925 427.42C392.079 431.222 391.287 435.085 389.602 438.758C385.2 436.87 380.734 430.939 378.842 422.597C379.021 398.839 388.181 375.04 404.971 354.715C421.761 334.389 445.289 318.614 472.082 309.719V309.719Z",
    fill: "url(#paint139_radial_329_4604)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M390.57 433.274C389.364 408.653 397.758 383.69 414.416 362.361C431.074 341.032 455.037 324.562 482.491 315.574C489.578 313.244 496.494 314.623 499.202 318.288C499.183 322.953 497.509 327.623 494.404 331.665C492.611 332.865 490.6 333.779 488.478 334.358C464.493 340.975 443.081 354.2 427.651 371.927C412.221 389.654 403.662 410.864 403.337 432.176L403.265 433.773C401.987 438.024 399.661 442.056 396.452 445.579C393.656 444.444 390.897 439.468 390.57 433.274Z",
    fill: "url(#paint140_radial_329_4604)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M464.914 336.669C468.445 338.565 472.716 339.489 477.188 339.325C481.66 339.161 486.132 337.916 490.038 335.747C493.945 333.579 497.11 330.585 499.133 327.143C501.157 323.702 501.948 319.967 501.407 316.413C500.866 312.859 499.016 309.643 496.092 307.174C493.169 304.705 489.302 303.093 484.982 302.542C480.661 301.991 476.081 302.525 471.82 304.077C467.56 305.63 463.81 308.13 461.045 311.263C457.34 315.462 455.666 320.497 456.392 325.261C457.117 330.025 460.183 334.129 464.914 336.669Z",
    fill: "url(#paint141_radial_329_4604)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M463.513 339.423C467.43 341.432 472.182 342.386 477.169 342.162C482.156 341.939 487.154 340.549 491.53 338.168C495.907 335.788 499.466 332.523 501.757 328.787C504.048 325.051 504.968 321.012 504.401 317.18C503.835 313.349 501.806 309.897 498.573 307.261C495.34 304.624 491.046 302.923 486.236 302.371C481.426 301.819 476.314 302.441 471.548 304.159C466.782 305.877 462.576 308.614 459.461 312.023C457.392 314.287 455.856 316.791 454.94 319.393C454.024 321.996 453.746 324.645 454.123 327.189C454.499 329.733 455.522 332.123 457.133 334.222C458.744 336.322 460.912 338.089 463.513 339.423Z",
    fill: "url(#paint142_radial_329_4604)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M492.35 307.797C488.488 305.497 483.768 304.461 478.94 304.855C474.112 305.249 469.452 307.049 465.699 309.97C461.946 312.892 459.315 316.767 458.224 320.981C457.132 325.196 457.643 329.508 459.674 333.234C456.984 329.632 455.88 325.216 456.553 320.752C457.227 316.289 459.635 312.059 463.361 308.797C467.087 305.534 471.896 303.445 476.952 302.892C482.009 302.338 486.995 303.356 491.045 305.767C493.886 307.495 496.161 309.836 497.676 312.59C496.264 310.703 494.46 309.079 492.35 307.797V307.797Z",
    fill: "url(#paint143_radial_329_4604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(944.288 1033.11) scale(1149.8 1149.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(944.286 1033.11) scale(1149.8 1149.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(944.338 1033.11) scale(1149.8 1149.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(944.29 1033.11) scale(1149.8 1149.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(514.8 456.025) scale(63.5016 63.5016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(593.615 281.361) scale(14.6874 14.6874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553.393 605.3) scale(14.2555 14.2555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1226.9 986.885) scale(14.2555 14.2555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1370.32 782.557) scale(4.89582 4.89583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1308.93 850.042) scale(9.79163 9.79164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1319.49 721.744) scale(19.5833 19.5833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(445.78 922.231) scale(4.89581 4.89582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.219 849.803) scale(9.79163 9.79163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.6 978.534) scale(19.5833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1465.26 754.998) rotate(129.987) scale(281.105 223.579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1438.64 718.952) rotate(129.987) scale(262.578 93.6212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1423.48 818.451) rotate(129.732) scale(239.282 239.282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1411.08 804.272) rotate(129.732) scale(247.451 247.451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1416.23 805.865) rotate(129.732) scale(51.5664 51.5664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1418.76 806.654) rotate(129.732) scale(57.6698 57.6698)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1419.23 807.361) rotate(129.732) scale(42.8679 42.8679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1415.63 802.678) rotate(129.732) scale(48.3945 48.3945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1340.71 777.028) rotate(129.732) scale(44.7902 44.7902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1380.36 734.139) rotate(150.113) scale(15.7494 15.7495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1379.81 734.236) rotate(150.114) scale(15.2678 15.2678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1378.7 742.09) rotate(150.047) scale(7.71361 5.68329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1378.7 742.09) rotate(150.047) scale(7.71361 5.68329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1378.43 742.136) rotate(150.046) scale(7.45208 5.49063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1394.73 762.661) rotate(-52.1992) scale(13.6496 10.0604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1395.13 762.389) rotate(-52.1992) scale(13.1946 9.72508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1382.09 759.304) rotate(117.13) scale(14.8789 10.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1381.72 759.703) rotate(117.13) scale(14.422 10.5787)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1396.5 763.367) rotate(161.384) scale(6.92867 6.92866)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1396.24 763.352) rotate(161.384) scale(6.68816 6.68811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1408.22 741.655) rotate(134.84) scale(10.1756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1408.22 741.655) rotate(134.84) scale(10.1756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1407.88 741.793) rotate(134.84) scale(9.83966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1377.97 777.14) rotate(-48.5901) scale(10.1756 10.1756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1378.3 776.982) rotate(-48.5899) scale(9.83964 9.83964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1376.16 737.105) rotate(-28.1062) scale(7.75742 7.75741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1376.16 737.105) rotate(-28.1062) scale(7.75742 7.75741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1376.46 737.052) rotate(-28.106) scale(7.51808 7.51803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1387.99 747.774) rotate(-28.1061) scale(6.12936 6.12934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1388.21 747.77) rotate(-28.106) scale(5.93778 5.93775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1397.02 781.903) rotate(-110.39) scale(14.3515 14.3515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1397.02 781.903) rotate(-110.39) scale(14.3515 14.3515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1397.03 781.387) rotate(-110.39) scale(13.9195 13.9195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1411.58 776.353) rotate(-133.12) scale(6.14375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1411.52 776.146) rotate(-133.12) scale(5.95178 5.95178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1390.68 730.782) rotate(72.0299) scale(6.14378 6.14383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1390.68 730.782) rotate(72.0299) scale(6.14378 6.14383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1390.65 730.993) rotate(72.0298) scale(5.95174 5.95179)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368.02 765.388) rotate(-28.0501) scale(13.6315 13.6315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368.49 765.355) rotate(-28.05) scale(13.1515 13.1515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1395.28 826.259) rotate(129.732) scale(2.40291 2.40291)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1390.8 821.791) rotate(129.733) scale(1.53788 1.53788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1398.67 776.462) rotate(129.732) scale(2.7393 2.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1404.36 783.752) rotate(129.732) scale(2.06648 2.06648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1385.66 784.521) rotate(129.732) scale(7.8335 7.8335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1384.9 790.7) rotate(129.732) scale(2.88347 2.88345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1380.49 787.661) rotate(129.732) scale(2.21068 2.21068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1402.54 771.429) rotate(129.732) scale(2.21065 2.21065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1409.33 788.755) rotate(129.732) scale(1.73011 1.73011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1418.43 809.006) rotate(129.732) scale(4.75775 4.75775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1413.2 798.533) rotate(129.732) scale(2.06649 2.06648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1422.82 808.157) rotate(129.733) scale(2.40292 2.40293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1424.95 799.803) rotate(129.733) scale(1.73008 1.73009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1410.75 817.563) rotate(129.732) scale(7.0165 7.0165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1406.28 806.032) rotate(129.733) scale(2.73933 2.73934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1401.68 829.079) rotate(129.732) scale(2.21066 2.21066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1393.23 818.495) rotate(129.732) scale(3.07571 3.0757)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1388.62 814.347) rotate(129.732) scale(2.73929 2.73928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1387.84 797.391) rotate(129.732) scale(2.4029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1379.46 807.991) rotate(129.732) scale(2.54711 2.54711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1376.13 805.091) rotate(129.732) scale(2.21069 2.21068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1369.15 798.977) rotate(129.732) scale(4.42138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1364.98 801.203) rotate(129.731) scale(1.3456 1.34559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1366.28 808.968) rotate(129.732) scale(1.20146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1377.92 824.89) rotate(129.732) scale(1.73007 1.73006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1390.57 830.72) rotate(129.733) scale(1.20149 1.2015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1414.2 805.301) rotate(129.732) scale(30.0363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(893.735 586.441) scale(408.657)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5186C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5187C6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#538AC7",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#558FC9",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5996CB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5DA0CE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#63ACD2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#69B9D6",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70C7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(775.069 414.22) scale(660.503 660.503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(817.956 349.565) scale(500.237 500.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(721.183 404.324) rotate(-27.07) scale(500.237 500.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1084.11 581.301) scale(1263.65 1263.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1032.28 445.225) rotate(-43.3865) scale(1269.27 1269.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(883.139 567.956) scale(416.48 416.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#743B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#71398C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#673284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#562676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#582678"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(881.508 564.934) scale(393.297 393.297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#743B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#71398C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#673284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#562676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#582678"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(514.656 829.835) scale(90.6686 90.6686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBBA00",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBB901",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FBB803",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAB606",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAB309",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F9B00E",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F9AD13",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F8A918",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A51E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(488.352 791.628) scale(146.538 146.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.855 777.278) scale(110.972)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(476.344 789.484) rotate(-27.07) scale(110.972 110.972)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(556.894 828.684) scale(280.357 280.357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(543.674 801.575) rotate(-43.3865) scale(281.616 281.616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1241.4 512.039) scale(75.2612 75.2612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5186C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5187C6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#538AC7",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#558FC9",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5996CB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5DA0CE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#63ACD2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#69B9D6",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70C7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1219.51 480.361) scale(121.675 121.675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1227.43 468.408) scale(92.1565 92.1566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1209.59 478.564) rotate(-27.07) scale(92.1565 92.1565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1276.44 511.128) scale(232.791 232.791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1269.16 489.617) rotate(-43.3865) scale(233.788 233.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1373.29 366.797) scale(23.9991 23.9991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBBA00",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBB901",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FBB803",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAB606",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAB309",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F9B00E",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F9AD13",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F8A918",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A51E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1366.29 356.717) scale(38.7825 38.7825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368.83 352.925) scale(29.3748 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1363.14 356.162) rotate(-27.07) scale(29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1384.43 366.509) scale(74.1573 74.1572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1384.68 362.246) rotate(-43.3865) scale(74.4901 74.4901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1054.2 584.948) scale(23.9991 23.9991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5186C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5187C6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#538AC7",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#558FC9",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5996CB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5DA0CE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#63ACD2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#69B9D6",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70C7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1047.25 574.868) scale(38.7825 38.7825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1049.79 571.078) scale(29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1044.05 574.324) rotate(-27.07) scale(29.3749 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1065.39 584.66) scale(74.1571 74.1572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1063.7 580.588) rotate(-43.3865) scale(74.4901 74.4901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(652.508 809.725) scale(23.9991 23.9991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5186C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5187C6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#538AC7",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#558FC9",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5996CB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5DA0CE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#63ACD2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#69B9D6",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70C7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(645.547 799.596) scale(38.7825 38.7825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(648.045 795.804) scale(29.3749 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(642.317 799.097) rotate(-27.07) scale(29.3749 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(663.69 809.436) scale(74.1572 74.1573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(659.628 805.355) rotate(-43.3865) scale(74.4901 74.4901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(708.188 747.614) scale(23.9991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBBA00",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBB901",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FBB803",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAB606",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAB309",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F9B00E",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F9AD13",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F8A918",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A51E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(701.227 737.487) scale(38.7825 38.7825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(703.72 733.696) scale(29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(697.991 736.954) rotate(-27.07) scale(29.3749 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(719.322 747.327) scale(74.1572 74.1572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(715.71 743.122) rotate(-43.3865) scale(74.4902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.653 820.091) scale(23.9991 23.9991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5186C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5187C6",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#538AC7",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#558FC9",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5996CB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5DA0CE",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#63ACD2",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#69B9D6",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70C7DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(368.696 810.012) scale(38.7825 38.7825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(371.24 806.171) scale(29.3749 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(365.473 809.436) rotate(-27.07) scale(29.3749 29.3749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(386.839 819.803) scale(74.1572 74.1572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.528 815.119) rotate(-43.3865) scale(74.4902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(740.776 418.538) scale(226.311)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978.944 452.522) scale(271.286 271.286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978.945 452.522) scale(271.286 271.286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(918.341 755.549) scale(78.429 78.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1053.05 740.943) scale(64.9895 64.9895)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5186C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.684 843.192) rotate(-104.971) scale(11.1582 12.1625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(470.017 280.437) rotate(129.187) scale(177.052 135.456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(496.453 290.626) rotate(129.626) scale(164.379 56.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.186 314.422) rotate(130.319) scale(152.687 145.058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.398 318.974) rotate(129.813) scale(155.803 148.982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7277F",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(442.977 317.076) rotate(131.7) scale(33.2614 30.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(442.591 317.725) rotate(132.666) scale(36.8123 33.7732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_329_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(442.105 315.723) rotate(129.245) scale(27.1122 26.104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFE135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18422"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_4604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1196.91,
    height: 1153.68,
    fill: "white",
    transform: "translate(266.806)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP001);
export default __webpack_public_path__ + "static/media/p001.cc5bcabd1898c79cca5e1356ff36e2fb.svg";
export { ForwardRef as ReactComponent };